/* Perle de Parfum — test olfactif. Fichier généré : catalogue + moteur + icônes + écran. */

/* ═══ catalogue.js ═══ */
/* Perle de Parfum — le catalogue du test olfactif, construit DANS LE NAVIGATEUR
 * à partir des fiches produits que la section écrit en Liquid.
 *
 * C'est la même logique que l'outil d'analyse de l'export (catalogue.py) :
 *  · un parfum = maison + nom (sans « - DÉCANT ») + concentration ; le décant
 *    et le flacon d'un même parfum ne font qu'un, la fiche décant en tête ;
 *  · la force de 22 grandes notes (0 à 1), d'après tête / cœur / fond, puis
 *    renforcée par la famille olfactive ;
 *  · 8 univers, et des traits : sucré, frais, chaleur, présence, tenue,
 *    soirée, été, hiver, genre.
 * Une fiche complétée dans l'admin compte donc dès le prochain chargement.
 *
 * Chaque produit reçu : { h, t, v, ty, ok, u, img, var: [{ id, ti, p, ok }],
 *   conc, fam: [], note: [], tete: [], coeur: [], fond: [], occ: [], sai: [],
 *   sexe, sil, ten, actif }
 */
(function (racine) {
  'use strict';

  var GROUPES = [
    ['agrumes', 'Agrumes', /bergamot|citron|mandarin|orange(?!r)|pamplemousse|yuzu|lime|cedrat|combava|neroli|petit-?grain|clementine|kumquat|agrume|bigarad|limette|verveine/, 0],
    ['aromatique', 'Lavande & herbes', /lavand|sauge|romarin|thym|basilic|menthe|estragon|armoise|absinthe|coriandre|aneth|camomille|fougere|geranium|laurier|eucalyptus|\bthe\b|the-|matcha|mate|gin\b|genevrier|davana|fenugrec|carotte/, -1],
    ['epices_fraiches', 'Épices fraîches', /gingembre|cardamome|poivre-rose|baies-rose|elemi|genievre/, 0],
    ['epices_chaudes', 'Épices chaudes', /safran|cannelle|clou|girofle|muscade|poivre(?!-rose)|cumin|piment|curcuma|anis|badiane|epice|safraleine|pimento|eugenol|reglisse/, -1],
    ['rose', 'Rose', /rose(?!-bois)|rosier|rosyfolia|petalia/, 1],
    ['fleurs_blanches', 'Fleurs blanches', /jasmin|sambac|tubereuse|fleur-d.?oranger|ylang|gardenia|frangipan|magnolia|muguet|lys|lis\b|lilas|osmanthus|champaca|orchid|narciss|freesia|fresia|tiare|chevrefeuille|mimosa|pivoine|fleur|florale|hedione|cyclamen|hibiscus|carnation|oeillet|immortelle/, 1],
    ['poudre', 'Iris & violette', /iris|violette|orris|heliotrop|poudre|aldehyde|cosmetique|rouge-a-levre|talc/, 1],
    ['fruits', 'Fruits', /pomme|poire|peche|nectarine|abricot|prune|cassis|framboise|fraise|cerise|litchi|mangue|mango|ananas|figue|melon|pasteque|grenade|fruit|baie|myrtille|mure|groseille|datte|rhubarbe|coing|banane|kiwi|coco(?!a)|passion|goyave|nashi|acai|papaye|neflier/, 1],
    ['gourmand', 'Gourmandises', /caramel|pralin|chocolat|cacao|cafe|miel|sucre|cassonade|amande|noisette|pistache|lait|lacte|creme|meringue|biscuit|guimauve|marshmallow|macaron|toffee|confiserie|rhum|cognac|whisky|liqueur|alcool|marron|nougat|gateau|financier|dulce|popcorn|latte|sesame|barbe-a-papa|glace|sorbet|riz/, 1],
    ['vanille', 'Vanille & tonka', /vanill|ultravanil|tonka|coumarin/, 0],
    ['ambre', 'Ambre & résines', /ambre(?!-?gris|x|fix|ttes|oxan|wood)|ambreine|labdanum|benjoin|benzoin|styrax|opopanax|myrrhe|tolu|copahu|resine|ciste|cistus|baume|balsam|baumier/, 0],
    ['musc', 'Musc & peau propre', /musc|musk|ambrette|cashmeran|habanolide|galaxolide|iso-e|ambroxan|ambrofix|ambre-gris|ambergris|cetalox|sylkolide|moxalone|civet|amberwood|orcanox|mahonial/, 0],
    ['santal', 'Santal', /santal|sandal|amyris/, 0],
    ['bois', 'Bois secs', /cedre|cypres|vetiver|bois|gaiac|pin\b|sapin|bouleau|teck|ebene|acajou|georgywood|akigalawood|papyrus|palo-santo|guaiac|cypriol|chene|pranol/, -1],
    ['patchouli', 'Patchouli & mousse', /patchouli|mousse|oakmoss|chypre|terre|racine|truffe/, 0],
    ['oud', 'Oud', /\boud|agarwood|agar/, -1],
    ['encens', 'Encens & fumé', /encens|oliban|fume|fumee|cade|incense|smoke/, -1],
    ['cuir', 'Cuir', /cuir|daim|suede|leather|castoreum/, -1],
    ['tabac', 'Tabac', /tabac|tobacco|foin|tabaco/, -1],
    ['aquatique', 'Marin & air frais', /marin|aquatique|ozon|\bsel\b|sale|calone|algue|\bmer\b|embrun|pluie|iode|solaire|sable/, 0],
    ['vert', 'Vert', /galbanum|feuille|vert|lierre|tige|bambou|herbe|figuier|tomate/, 0],
    ['mineral', 'Minéral', /mineral|metal|pierre|silex/, 0]
  ];
  var CLES = GROUPES.map(function (g) { return g[0]; });

  // Famille (handle du métaobjet) → grandes notes renforcées.
  // « poudre » est la famille MUSQUÉ, « poudre-1 » la famille POUDRÉ.
  var FAMILLES = {
    'floral': { fleurs_blanches: .55, rose: .45 }, 'oriental': { ambre: .6, epices_chaudes: .45, vanille: .4 },
    'poudre-1': { poudre: .7 }, 'poudre': { musc: .7 }, 'cuire': { cuir: .8 }, 'fruite': { fruits: .7 },
    'ambre': { ambre: .7 }, 'boise': { bois: .6, santal: .35 }, 'epice': { epices_chaudes: .6, epices_fraiches: .3 },
    'gourmand': { gourmand: .7, vanille: .45 }, 'aromatique': { aromatique: .7 }, 'hesperide': { agrumes: .8 },
    'aldehydee': { poudre: .4, musc: .4 }, 'aquatique': { aquatique: .8 }, 'chypre': { patchouli: .6, agrumes: .3 },
    'fougere': { aromatique: .6, vanille: .3 }, 'vert': { vert: .7 }, 'musque': { musc: .7 }
  };
  var LIB_FAMILLE = { 'floral': 'Floral', 'oriental': 'Oriental', 'poudre-1': 'Poudré', 'poudre': 'Musqué', 'cuire': 'Cuiré',
    'fruite': 'Fruité', 'ambre': 'Ambré', 'boise': 'Boisé', 'epice': 'Épicé', 'gourmand': 'Gourmand',
    'aromatique': 'Aromatique', 'hesperide': 'Hespéridé', 'aldehydee': 'Aldéhydé', 'aquatique': 'Aquatique',
    'chypre': 'Chypré', 'fougere': 'Fougère', 'vert': 'Vert', 'musque': 'Musqué' };
  var LIB_CONC = { 'eau-de-parfum': 'Eau de parfum', 'extrait-de-parfum': 'Extrait de parfum', 'absolu-de-parfum': 'Absolu de parfum',
    'eau-de-toilette': 'Eau de toilette', 'eau-de-cologne': 'Eau de cologne' };
  var UNIVERS = [
    ['frais', 'Frais & lumineux', { agrumes: 1, aquatique: 1, vert: .9, aromatique: .8, epices_fraiches: .5, mineral: .8 }],
    ['fruite', 'Fruité', { fruits: 1 }],
    ['floral', 'Floral', { rose: 1, fleurs_blanches: 1 }],
    ['poudre', 'Poudré & doux', { poudre: 1, musc: .85 }],
    ['gourmand', 'Gourmand', { gourmand: 1, vanille: .8 }],
    ['oriental', 'Oriental & ambré', { ambre: 1, epices_chaudes: .9, vanille: .5 }],
    ['sombre', 'Sombre & intense', { cuir: 1, oud: 1, encens: 1, tabac: 1 }],
    ['boise', 'Boisé', { bois: 1, santal: .9, patchouli: .9 }]
  ];

  function r3(x) { return Math.round(x * 1000) / 1000; }
  function sansDecant(t) { return String(t || '').replace(/\s*-\s*D[ÉE]CANT\s*$/i, '').trim(); }
  function joli(t) { return String(t || '').split(' ').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' '); }
  function cle(t) { return sansDecant(t).normalize('NFKD').replace(/[̀-ͯ]/g, '').toUpperCase().trim(); }
  function estDecant(p) { return /d[ée]cant/i.test(p.ty || ''); }
  function joliNote(n) { var t = String(n).replace(/-/g, ' ').replace(/\s+/g, ' ').trim(); return t.charAt(0).toUpperCase() + t.slice(1); }
  function nombre(v) { var x = parseFloat(v); return isNaN(x) ? null : x; }

  function propre(l) { return (l || []).filter(function (x) { return x !== '' && x !== null && x !== undefined; }); }
  function construire(produits) {
    // Listes nettoyées : une valeur vide ne doit jamais compter comme une note.
    produits = produits.map(function (p) {
      var c = {}; for (var k in p) c[k] = p[k];
      ['fam', 'note', 'tete', 'coeur', 'fond', 'occ', 'sai'].forEach(function (k) { c[k] = propre(p[k]); });
      return c;
    });
    // Regroupement : maison + nom + concentration.
    var groupes = {}, ordre = [];
    produits.forEach(function (p) {
      var k = String(p.v || '').toUpperCase() + '|' + cle(p.t) + '|' + (p.conc || '');
      if (!groupes[k]) { groupes[k] = []; ordre.push(k); }
      groupes[k].push(p);
    });
    var parfums = ordre.map(function (k) {
      var x = groupes[k].slice().sort(function (a, b) { return (estDecant(b) ? 1 : 0) - (estDecant(a) ? 1 : 0); });
      var ref = x[0];
      function premier(champ) {
        for (var i = 0; i < x.length; i++) {
          var v = x[i][champ];
          if (Array.isArray(v) ? v.length : (v !== null && v !== undefined && v !== '')) return v;
        }
        return null;
      }
      var tete = premier('tete') || [], coeur = premier('coeur') || [], fond = premier('fond') || [], toutes = premier('note') || [];
      var sources = (tete.length || coeur.length || fond.length) ? [[tete, .6], [coeur, .85], [fond, 1]] : [[toutes, .8]];
      var poids = {}, nbNotes = 0;
      sources.forEach(function (s) {
        s[0].forEach(function (n) {
          nbNotes++;
          GROUPES.forEach(function (g) { if (g[2].test(n)) poids[g[0]] = (poids[g[0]] || 0) + s[1]; });
        });
      });
      var force = {};
      CLES.forEach(function (g) { force[g] = 1 - Math.exp(-(poids[g] || 0) / 1.1); });
      var familles = premier('fam') || [];
      familles.forEach(function (f) {
        var b = FAMILLES[f] || {};
        for (var g in b) force[g] = Math.max(force[g], b[g]);
      });
      var u = {};
      UNIVERS.forEach(function (un) {
        var m = 0; for (var g in un[2]) m = Math.max(m, force[g] * un[2][g]);
        u[un[0]] = r3(Math.min(1, m));
      });
      var conc = premier('conc') || '';
      var sexe = String(premier('sexe') || '').trim();
      var tot = 0, pen = 0;
      GROUPES.forEach(function (g) { tot += force[g[0]]; pen += force[g[0]] * g[3]; });
      var genre = pen / (tot || 1) * 2.2;
      if (sexe === 'femme') genre = .4 * genre + .6; else if (sexe === 'homme') genre = .4 * genre - .6;
      genre = Math.max(-1, Math.min(1, genre));
      var sucre = Math.max(force.gourmand, force.vanille * .85, force.fruits * .6);
      var frais = Math.max(force.agrumes, force.aquatique, force.vert, force.aromatique * .8, force.epices_fraiches * .6);
      var chaleur = Math.max(force.ambre, force.vanille * .9, force.epices_chaudes, force.oud, force.encens, force.cuir, force.tabac * .85);
      var dec = x.filter(estDecant)[0] || null;
      // Le grand format : le flacon (fiche non « décant ») encore en vente.
      var flacon = null;
      x.filter(function (p) { return !estDecant(p) && p.actif !== false; }).some(function (p) {
        var vs = (p.var || []).filter(function (v) { return v.ok; });
        if (!vs.length) return false;
        flacon = { h: p.h, u: p.u, var: vs.map(function (v) { return { id: v.id, ti: v.ti, p: v.p }; }) };
        return true;
      });
      var sillage = nombre(premier('sil')), tenue = nombre(premier('ten'));
      var g3 = {}; CLES.forEach(function (g) { g3[g] = r3(force[g]); });
      // Les notes à montrer : le fond d'abord, c'est ce qui reste.
      var vues = [];
      fond.concat(coeur, tete, (tete.length || coeur.length || fond.length) ? [] : toutes).forEach(function (n) {
        var j = joliNote(n);
        if (!vues.some(function (v) { return v.toLowerCase() === j.toLowerCase(); })) vues.push(j);
      });
      return {
        nom: joli(sansDecant(ref.t)), maison: joli(ref.v || ''),
        produit: dec || ref, decantFiche: dec, decant: !!dec, flacon: dec ? flacon : null,
        // Toutes les fiches du parfum (achats du client) : identifiant + « fiche décant ? ».
        hs: x.map(function (p) { return { h: p.h, d: estDecant(p) }; }),
        dispo: x.some(function (p) { return p.ok; }),
        actif: x.some(function (p) { return p.actif !== false; }),
        conc: LIB_CONC[conc] || conc, extrait: conc === 'extrait-de-parfum' || conc === 'absolu-de-parfum',
        familles: familles.map(function (f) { return LIB_FAMILLE[f] || f; }),
        notes: vues.slice(0, 5),
        g: g3, u: u, sillage: sillage, tenue: tenue,
        occasion: premier('occ') || [], saison: premier('sai') || [], sexe: sexe,
        t: { sucre: r3(sucre), frais: r3(frais), chaleur: r3(chaleur), genre: r3(genre) },
        qualite: Math.round((Math.min(1, nbNotes / 6) * .6 + (familles.length ? .2 : 0) + (sillage ? .2 : 0)) * 100) / 100
      };
    });
    // Présence et tenue : rang dans le catalogue.
    function rang(vals) {
      var s = vals.filter(function (v) { return v !== null; }).sort(function (a, b) { return a - b; });
      return function (v) {
        if (v === null) return null;
        var inf = 0, eg = 0;
        s.forEach(function (w) { if (w < v) inf++; else if (w === v) eg++; });
        return (inf + .5 * eg) / s.length;
      };
    }
    var pres = parfums.map(function (p) { return p.sillage === null ? null : p.sillage + (p.extrait ? 1.2 : 0); });
    var rp = rang(pres), rt = rang(parfums.map(function (p) { return p.tenue; }));
    parfums.forEach(function (p, i) {
      var t = p.t;
      t.presence = pres[i] === null ? null : r3(rp(pres[i]));
      t.tenue = p.tenue === null ? null : r3(rt(p.tenue));
      var est = t.presence !== null ? t.presence : .5;
      if (p.occasion.length) { t.soiree = p.occasion.indexOf('soiree') >= 0 ? 1 : .25; t.soiree_estime = false; }
      else { t.soiree = r3(.55 * est + .45 * t.chaleur); t.soiree_estime = true; }
      if (p.saison.length) {
        var s = p.saison[0];
        t.ete = { 'saisons-chaudes': 1, 'toutes-saisons': .6, 'saisons-froides': .1 }[s]; if (t.ete === undefined) t.ete = .5;
        t.hiver = { 'saisons-chaudes': .1, 'toutes-saisons': .6, 'saisons-froides': 1 }[s]; if (t.hiver === undefined) t.hiver = .5;
        t.saison_estimee = false;
      } else {
        t.ete = r3(.2 + .7 * t.frais - .25 * t.chaleur + .1);
        t.hiver = r3(.2 + .7 * t.chaleur - .2 * t.frais + .1);
        t.saison_estimee = true;
      }
      t.ete = Math.max(0, Math.min(1, t.ete)); t.hiver = Math.max(0, Math.min(1, t.hiver));
    });
    return {
      meta: {
        groupes: GROUPES.map(function (g) { return { k: g[0], lib: g[1], genre: g[3] }; }),
        univers: UNIVERS.map(function (u) { return { k: u[0], lib: u[1] }; })
      },
      parfums: parfums
    };
  }

  var API = { construire: construire };
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  else racine.PdpTestCatalogue = API;
})(this);

/* ═══ moteur.js ═══ */
/* Perle de Parfum — moteur du test olfactif « à la Akinator ».
 *
 * Chaque parfum du catalogue porte la force de 22 grandes notes (g), 8 univers
 * (u) et des traits (t : sucré, frais, chaleur, présence, tenue, soirée, été,
 * hiver, genre). Chaque question vise une ou plusieurs de ces valeurs.
 *
 * À chaque réponse (Oui 1 · Plutôt oui 0,5 · Je ne sais pas 0 · Plutôt non
 * −0,5 · Non −1), chaque parfum gagne ou perd des points selon qu'il est fort
 * ou faible sur ce que vise la question, comparé au reste du catalogue. La
 * question suivante est celle qui DÉPARTAGE le mieux les parfums encore en
 * tête. Le test s'arrête quand il est sûr de lui.
 *
 * Le même fichier sert à la page et au banc de simulation (Node).
 */
(function (racine) {
  'use strict';

  // ─── LA BANQUE DE QUESTIONS ────────────────────────────────────────────
  // cible : [[valeur, poids], …] — « g.x » une grande note, « t.x » un trait.
  // themes : ce qu'elle partage avec ses voisines (pour ne pas les enchaîner).
  var QUESTIONS = [
    // Les odeurs du quotidien
    { id: 'agrumes', texte: 'Le zeste d\'une orange qu\'on épluche, ça vous plaît ?', aide: 'Citron, bergamote, mandarine…', cible: [['g.agrumes', 1]], themes: ['frais'] },
    { id: 'mer', texte: 'L\'air de la mer, une brise après la pluie ?', aide: 'Embruns, sel, fraîcheur d\'air', cible: [['g.aquatique', 1]], themes: ['frais'] },
    { id: 'vert', texte: 'L\'herbe fraîchement coupée, une feuille qu\'on froisse ?', aide: 'Vert, croquant, nature', cible: [['g.vert', 1]], themes: ['frais'] },
    { id: 'lavande', texte: 'La lavande, la garrigue, les herbes de Provence ?', aide: 'Thym, sauge, romarin…', cible: [['g.aromatique', 1]], themes: ['frais', 'masc'] },
    { id: 'gingembre', texte: 'Le gingembre frais, la cardamome d\'un thé chaï ?', aide: 'Épices qui piquent sans chauffer', cible: [['g.epices_fraiches', 1]], themes: ['epice'] },
    { id: 'rose', texte: 'Le parfum d\'un bouquet de roses ?', aide: 'Velouté, romantique', cible: [['g.rose', 1]], themes: ['fleur'] },
    { id: 'jasmin', texte: 'Un jardin de jasmin ou de fleur d\'oranger, le soir ?', aide: 'Fleurs blanches, capiteuses', cible: [['g.fleurs_blanches', 1]], themes: ['fleur'] },
    { id: 'poudre', texte: 'Le maquillage poudré, un rouge à lèvres ancien ?', aide: 'Iris, violette, douceur poudrée', cible: [['g.poudre', 1]], themes: ['doux'] },
    { id: 'linge', texte: 'Le linge propre qui sèche au soleil, une peau après la douche ?', aide: 'Muscs, propreté, cocon', cible: [['g.musc', 1], ['g.poudre', .25]], themes: ['doux'] },
    { id: 'fruits', texte: 'Un bonbon aux fruits rouges, une pêche bien juteuse ?', aide: 'Fruité, pétillant', cible: [['g.fruits', 1]], themes: ['sucre'] },
    { id: 'patisserie', texte: 'L\'odeur d\'une pâtisserie : caramel, praliné, café ?', aide: 'Gourmand, régressif', cible: [['g.gourmand', 1]], themes: ['sucre'] },
    { id: 'vanille', texte: 'Une gousse de vanille, une fève tonka ?', aide: 'Rond, chaud, réconfortant', cible: [['g.vanille', 1]], themes: ['sucre', 'chaud'] },
    { id: 'souk', texte: 'Les épices d\'un souk : cannelle, safran, poivre ?', aide: 'Chaleur épicée', cible: [['g.epices_chaudes', 1]], themes: ['epice', 'chaud'] },
    { id: 'ambre', texte: 'Un ambre chaud, des résines, un baume ?', aide: 'Enveloppant, doré', cible: [['g.ambre', 1]], themes: ['chaud'] },
    { id: 'crayon', texte: 'Un crayon de bois qu\'on taille, du cèdre, du vétiver ?', aide: 'Bois sec, net', cible: [['g.bois', 1]], themes: ['bois', 'masc'] },
    { id: 'santal', texte: 'Un bois crémeux et doux, comme le santal ?', aide: 'Lacté, apaisant', cible: [['g.santal', 1]], themes: ['bois'] },
    { id: 'foret', texte: 'Un sous-bois, de la terre humide, de la mousse ?', aide: 'Patchouli, forêt après la pluie', cible: [['g.patchouli', 1]], themes: ['bois'] },
    { id: 'oud', texte: 'Un bois précieux, profond, un peu animal, comme l\'oud ?', aide: 'Intense, oriental', cible: [['g.oud', 1]], themes: ['sombre', 'chaud'] },
    { id: 'feu', texte: 'Un feu de cheminée, l\'encens d\'une église ?', aide: 'Fumé, mystique', cible: [['g.encens', 1]], themes: ['sombre'] },
    { id: 'cuir', texte: 'L\'odeur d\'une veste en cuir neuve ?', aide: 'Cuir, daim', cible: [['g.cuir', 1]], themes: ['sombre', 'masc'] },
    { id: 'tabac', texte: 'Du tabac blond, un cigare, du foin séché ?', aide: 'Chaud, miellé, sec', cible: [['g.tabac', 1]], themes: ['sombre'] },
    { id: 'mineral', texte: 'Une pierre mouillée, un métal froid ?', aide: 'Minéral, original', cible: [['g.mineral', 1]], themes: ['frais'] },
    // Les envies
    { id: 'sucre', texte: 'Un parfum sucré, ça vous tente ?', aide: 'Plutôt dessert que zeste', cible: [['t.sucre', 1]], themes: ['sucre'] },
    { id: 'cocon', texte: 'Une odeur qui vous enveloppe comme un pull en cachemire ?', aide: 'Chaleur, douceur', cible: [['t.chaleur', 1]], themes: ['chaud'] },
    { id: 'reveil', texte: 'Une odeur qui réveille, comme une douche fraîche ?', aide: 'Énergie, légèreté', cible: [['t.frais', 1]], themes: ['frais'] },
    { id: 'presence', texte: 'Aimez-vous qu\'on vous remarque quand vous entrez dans une pièce ?', aide: 'Un parfum qui se sent de loin', cible: [['t.presence', 1]], themes: ['intensite'] },
    { id: 'tenue', texte: 'Votre parfum doit-il tenir du matin au soir ?', aide: 'Longue tenue', cible: [['t.tenue', 1]], themes: ['intensite'] },
    { id: 'soiree', texte: 'C\'est surtout pour sortir le soir ?', aide: 'Plutôt soirée que bureau', cible: [['t.soiree', 1]], themes: ['moment'] },
    { id: 'ete', texte: 'Vous le porteriez surtout l\'été ?', aide: 'Chaleur, vacances', cible: [['t.ete', 1]], themes: ['saison'] },
    { id: 'hiver', texte: 'Plutôt pour l\'hiver, quand il fait froid ?', aide: 'Saisons froides', cible: [['t.hiver', 1]], themes: ['saison'] },
    { id: 'genre', texte: 'Côté style, vous allez plutôt vers…', aide: 'Presque tous nos parfums sont unisexes : c\'est une préférence, pas un filtre.', cible: [['t.genre', 1]], themes: ['genre'], douce: true,
      reponses: [['Les codes féminins', 1], ['Plutôt féminin', .5], ['Peu importe', 0], ['Plutôt masculin', -.5], ['Les codes masculins', -1]] }
  ];

  // Ce qu'on veut écarter : des « types » de parfum, pas des notes isolées.
  var EXCLUSIONS = [
    { k: 'fruite', lib: 'Trop fruité', ico: 'fruits', q: 'fruits', cible: [['g.fruits', 1]] },
    { k: 'sucre', lib: 'Trop sucré', ico: 'sucre', q: 'sucre', cible: [['t.sucre', 1]] },
    { k: 'oud', lib: 'Oud animal', ico: 'oud', q: 'oud', cible: [['g.oud', 1]] },
    { k: 'fleuri', lib: 'Trop fleuri', ico: 'jasmin', q: 'jasmin', cible: [['g.fleurs_blanches', 0.6], ['g.rose', 0.4]] },
    { k: 'poudre', lib: 'Trop poudré', ico: 'poudre', q: 'poudre', cible: [['g.poudre', 1]] },
    { k: 'vanille', lib: 'Trop vanillé', ico: 'vanille', q: 'vanille', cible: [['g.vanille', 1]] },
    { k: 'epice', lib: 'Trop épicé', ico: 'souk', q: 'souk', cible: [['g.epices_chaudes', 1]] },
    { k: 'fume', lib: 'Fumé, encens', ico: 'feu', q: 'feu', cible: [['g.encens', 1]] },
    { k: 'cuir', lib: 'Cuir', ico: 'cuir', q: 'cuir', cible: [['g.cuir', 1]] },
    { k: 'tabac', lib: 'Tabac', ico: 'tabac', q: 'tabac', cible: [['g.tabac', 1]] },
    { k: 'musc', lib: 'Trop « propre », musqué', ico: 'linge', q: 'linge', cible: [['g.musc', 1]] },
    { k: 'frais', lib: 'Trop frais, marin', ico: 'mer', q: 'mer', cible: [['g.aquatique', 0.6], ['g.agrumes', 0.4]] }
  ];

  var REPONSES = [['Oui', 1], ['Plutôt oui', .5], ['Je ne sais pas', 0], ['Plutôt non', -.5], ['Non', -1]];

  // Le cercle des univers : voisins = proches, à l'opposé = audace.
  var CERCLE = ['frais', 'fruite', 'floral', 'poudre', 'gourmand', 'oriental', 'sombre', 'boise'];

  function lire(p, cle) {
    var b = cle.split('.');
    var v = b[0] === 'g' ? p.g[b[1]] : p.t[b[1]];
    if (v === null || v === undefined) return null;
    if (b[1] === 'genre') return (v + 1) / 2; // −1…1 → 0…1
    return v;
  }
  function valeur(p, q) {
    var s = 0, w = 0;
    for (var i = 0; i < q.cible.length; i++) {
      var v = lire(p, q.cible[i][0]);
      if (v === null) continue;
      s += v * q.cible[i][1]; w += q.cible[i][1];
    }
    return w ? s / w : null;
  }

  function Moteur(catalogue, options) {
    options = options || {};
    this.K = options.K || 0.75;           // force d'une réponse
    this.MIN = options.min || 10;
    this.MAX = options.max || 18;
    this.SEUIL = options.seuil || 0.75;   // part des 5 premiers pour s'arrêter
    this.parfums = catalogue.parfums;
    this.meta = catalogue.meta;
    var n = this.parfums.length;
    // Valeur de chaque parfum pour chaque question, centrée-réduite.
    this.z = {};
    for (var qi = 0; qi < QUESTIONS.length; qi++) {
      var q = QUESTIONS[qi], xs = [], s = 0, s2 = 0, c = 0;
      for (var i = 0; i < n; i++) {
        var x = valeur(this.parfums[i], q);
        xs.push(x);
        if (x !== null) { s += x; s2 += x * x; c++; }
      }
      var mu = c ? s / c : 0, sd = c ? Math.sqrt(Math.max(1e-6, s2 / c - mu * mu)) : 1;
      // Bornée : une note rare (minéral…) donnerait sinon des écarts énormes
      // à une poignée de parfums, et passerait pour très discriminante.
      this.z[q.id] = xs.map(function (x) { return x === null ? null : Math.max(-2.2, Math.min(2.2, (x - mu) / sd)); });
    }
    this.reset();
  }

  Moteur.prototype.reset = function () {
    var self = this;
    // A priori : une fiche mal renseignée part un peu derrière.
    this.logit = this.parfums.map(function (p) { return 1.2 * (p.qualite - 1); });
    this.reponses = [];   // [{id, u}]
    this.poses = {};
    this.reference = null;
    this.choix = null;
    this.notesAimees = [];   // grandes notes cochées « j'adore »
    this.moment = null; this.saison = null;
    this.exclusions = [];    // types écartés (EXCLUSIONS)
    this.exclus = {};        // parfums retirés de la sélection (déjà eu, pas aimé)
  };

  // « Les notes que vous adorez » : comme un « Oui » franc à chacune, et la
  // question qui la mesure n'est plus posée.
  Moteur.prototype.aimerNotes = function (cles) {
    var self = this;
    this.notesAimees = cles.slice();
    cles.forEach(function (k) {
      var q = QUESTIONS.filter(function (x) { return x.cible[0][0] === 'g.' + k; })[0];
      if (!q) return;
      var z = self.z[q.id];
      for (var i = 0; i < self.logit.length; i++) if (z[i] !== null) self.logit[i] += self.K * 1.2 * z[i];
      self.poses[q.id] = true;
    });
    this.reponses.push({ id: '_notes', u: 0 });
  };

  // « Ce que vous voulez éviter » : un parfum où ce type domine passe loin
  // derrière, et la question correspondante n'est plus posée.
  Moteur.prototype.exclure = function (cles) {
    var self = this;
    this.exclusions = EXCLUSIONS.filter(function (e) { return cles.indexOf(e.k) >= 0; });
    this.exclusions.forEach(function (e) {
      for (var i = 0; i < self.parfums.length; i++) {
        var x = valeur(self.parfums[i], e);
        if (x !== null && x > 0.45) self.logit[i] -= 6 * (x - 0.45) / 0.55;
      }
      self.poses[e.q] = true;
    });
    this.reponses.push({ id: '_exclus', u: 0 });
  };

  /* « Pour quand ? » : le moment, puis la saison, en un écran. Chaque choix
     agit comme une réponse franche aux questions soirée / été / hiver, qui
     ne sont plus posées ensuite. « Les deux », « Toute l'année » : aucun
     penchant, mais la question est réglée. */
  Moteur.prototype.quand = function (moment, saison) {
    var self = this, K = this.K;
    function pousse(id, u) {
      var z = self.z[id];
      for (var i = 0; i < self.logit.length; i++) if (z[i] !== null) self.logit[i] += K * u * z[i];
    }
    if (moment === 'soir') pousse('soiree', 1); else if (moment === 'jour') pousse('soiree', -1);
    if (saison === 'chaud') { pousse('ete', 1); pousse('hiver', -0.5); }
    else if (saison === 'froid') { pousse('hiver', 1); pousse('ete', -0.5); }
    this.moment = moment; this.saison = saison;
    this.poses.soiree = true; this.poses.ete = true; this.poses.hiver = true;
    this.bonus = (this.bonus || 0) + 1; // en plus : ne prend la place d'aucune question
  };

  function cosinus(a, b, cles) {
    var s = 0, na = 0, nb = 0;
    cles.forEach(function (k) { var x = a.g[k] || 0, y = b.g[k] || 0; s += x * y; na += x * x; nb += y * y; });
    return na && nb ? s / Math.sqrt(na * nb) : 0;
  }
  /* Une recommandation écartée par le client.
     « deja » : il l'a déjà — il l'aime sans doute, ses voisins remontent un peu.
     « naime » : il n'aime pas — ses voisins descendent. */
  Moteur.prototype.rejeter = function (i, raison) {
    var P = this.parfums, ref = P[i], cles = this.meta.groupes.map(function (g) { return g.k; });
    this.exclus[i] = true;
    for (var j = 0; j < P.length; j++) {
      if (j === i) continue;
      var c = cosinus(ref, P[j], cles);
      if (raison === 'naime') this.logit[j] -= 3 * Math.max(0, c - 0.55) / 0.45;
      else this.logit[j] += 0.8 * Math.max(0, c - 0.65) / 0.35;
    }
  };
  // Le meilleur parfum qui n'est ni affiché ni écarté, avec son pourcentage.
  Moteur.prototype.remplacant = function (affiches, filtre) {
    var self = this, P = this.parfums;
    filtre = filtre || function () { return true; };
    var ordre = this.classement();
    for (var j = 0; j < ordre.length; j++) {
      var i = ordre[j];
      if (this.exclus[i] || affiches.indexOf(i) >= 0 || !filtre(P[i])) continue;
      return { i: i, parfum: P[i], pct: this.pct(i), pourquoi: this.pourquoi(P[i]) };
    }
    return null;
  };
  Moteur.prototype.pct = function (i) {
    var e = this.echelle || { Lmax: this.logit[i], spread: 1, haut: 90 };
    return Math.max(40, Math.min(e.haut, Math.round(e.haut * Math.exp(-0.9 * (e.Lmax - this.logit[i]) / e.spread))));
  };

  Moteur.prototype.poids = function () {
    var m = -Infinity, L = this.logit, w = new Array(L.length), s = 0, i;
    for (i = 0; i < L.length; i++) if (L[i] > m) m = L[i];
    for (i = 0; i < L.length; i++) { w[i] = Math.exp(L[i] - m); s += w[i]; }
    for (i = 0; i < L.length; i++) w[i] /= s;
    return w;
  };

  Moteur.prototype.repondre = function (id, u) {
    var z = this.z[id], k = this.K, q = QUESTIONS.filter(function (x) { return x.id === id; })[0];
    if (q && q.douce) k *= 0.45; // « pour qui » : un léger penchant, pas un filtre
    if (u !== 0) {
      for (var i = 0; i < this.logit.length; i++) {
        if (z[i] === null) continue;
        // Un « non » franc à une odeur pèse plus lourd sur les parfums où
        // elle domine : on ne propose pas ce qu'on n'aime pas.
        var f = (u < 0 && z[i] > 1) ? 1.5 : 1;
        this.logit[i] += k * f * u * z[i];
      }
    }
    this.reponses.push({ id: id, u: u });
    this.poses[id] = true;
  };

  // Un parfum déjà aimé : on rapproche ceux qui lui ressemblent.
  Moteur.prototype.parfumAime = function (index) {
    var ref = this.parfums[index], self = this;
    this.reference = index;
    var cles = this.meta.groupes.map(function (g) { return g.k; });
    function vec(p) { return cles.map(function (k) { return p.g[k] || 0; }); }
    var a = vec(ref), na = Math.sqrt(a.reduce(function (s, v) { return s + v * v; }, 0)) || 1;
    for (var i = 0; i < this.parfums.length; i++) {
      if (i === index) { this.logit[i] -= 50; continue; } // on ne lui propose pas le sien
      var b = vec(this.parfums[i]), nb = Math.sqrt(b.reduce(function (s, v) { return s + v * v; }, 0)) || 1;
      var cos = a.reduce(function (s, v, j) { return s + v * b[j]; }, 0) / (na * nb);
      this.logit[i] += 3.2 * (cos - 0.5);
    }
  };

  Moteur.prototype.prochaine = function () {
    var w = this.poids(), meilleur = null, score = -1, self = this;
    var themesVus = {};
    this.reponses.forEach(function (r) {
      var q = QUESTIONS.filter(function (x) { return x.id === r.id; })[0];
      if (!q) return;
      (q.themes || []).forEach(function (t) { themesVus[t] = (themesVus[t] || 0) + 1; });
    });
    var dernier = this.reponses.length ? QUESTIONS.filter(function (x) { return x.id === self.reponses[self.reponses.length - 1].id; })[0] || null : null;
    for (var qi = 0; qi < QUESTIONS.length; qi++) {
      var q = QUESTIONS[qi];
      if (this.poses[q.id]) continue;
      var z = this.z[q.id], m = 0, sw = 0, i;
      for (i = 0; i < z.length; i++) if (z[i] !== null) { m += w[i] * z[i]; sw += w[i]; }
      if (sw < 0.3) continue; // la question ne concerne presque aucun parfum en tête
      m /= sw;
      var v = 0;
      for (i = 0; i < z.length; i++) if (z[i] !== null) v += w[i] * (z[i] - m) * (z[i] - m);
      v /= sw;
      // Variété : ne pas enchaîner deux questions du même thème.
      var deja = 0;
      (q.themes || []).forEach(function (t) { deja += themesVus[t] || 0; });
      var s = v * sw / (1 + 0.35 * deja);
      if (dernier && (q.themes || []).some(function (t) { return (dernier.themes || []).indexOf(t) >= 0; })) s *= 0.6;
      if (q.douce) s *= 0.8;
      if (s > score) { score = s; meilleur = q; }
    }
    this.dernierScore = score;
    return meilleur;
  };

  // Confiance : la part des 5 parfums en tête.
  Moteur.prototype.confiance = function () {
    var w = this.poids().slice().sort(function (a, b) { return b - a; });
    return w[0] + w[1] + w[2] + w[3] + w[4];
  };

  // Ce que montre la jauge « Je cerne votre profil » (0 à 1).
  Moteur.prototype.jauge = function () {
    var n = this.reponses.length;
    return Math.min(1, Math.max(n / this.MAX, this.confiance() / this.SEUIL, 0));
  };

  Moteur.prototype.fini = function () {
    var n = this.reponses.length;
    if (n >= this.MAX) return true;
    if (n < this.MIN) return false;
    if (this.confiance() >= this.SEUIL) return true;
    var q = this.prochaine();
    return !q || this.dernierScore < 0.08;
  };

  Moteur.prototype.classement = function () {
    var L = this.logit;
    return L.map(function (v, i) { return i; }).sort(function (a, b) { return L[b] - L[a]; });
  };

  // ─── Le résultat ────────────────────────────────────────────────────────
  Moteur.prototype.resultat = function (opts) {
    opts = opts || {};
    var self = this, P = this.parfums, ordre = this.classement(), w = this.poids();
    var filtre = opts.filtre || function () { return true; };
    var ok = ordre.filter(function (i) { return filtre(P[i]) && !self.exclus[i]; });
    var top = ok.slice(0, 5);
    var conf = this.confiance();
    var Lmax = this.logit[top[0]];
    var spread = Math.max(0.6, this.logit[ok[0]] - this.logit[ok[Math.min(29, ok.length - 1)]]);
    var haut = Math.round(82 + 16 * Math.min(1, conf / 0.8));
    this.echelle = { Lmax: Lmax, spread: spread, haut: haut };
    var cinq = top.map(function (i) {
      return { i: i, parfum: P[i], pct: self.pct(i), pourquoi: self.pourquoi(P[i]) };
    });

    // Le profil : la moyenne des parfums en tête, pondérée.
    var tete = ok.slice(0, 15), sw = 0;
    var univ = {}, traits = { presence: 0, soiree: 0, ete: 0, hiver: 0, genre: 0 };
    this.meta.univers.forEach(function (u) { univ[u.k] = 0; });
    tete.forEach(function (i) {
      var p = P[i], k = w[i] + 1e-9; sw += k;
      for (var u in univ) univ[u] += k * (p.u[u] || 0);
      for (var t in traits) traits[t] += k * (p.t[t] === null || p.t[t] === undefined ? 0.5 : p.t[t]);
    });
    for (var u2 in univ) univ[u2] /= sw;
    for (var t2 in traits) traits[t2] /= sw;
    var univers = this.meta.univers.map(function (u) { return { k: u.k, lib: u.lib, v: univ[u.k] }; })
      .sort(function (a, b) { return b.v - a.v; });
    var maxU = univers[0].v || 1;
    univers.forEach(function (u) { u.pct = Math.round(100 * u.v / maxU); });

    var aimes = [], evites = [];
    var libDe = function (k) { return self.meta.groupes.filter(function (x) { return x.k === k; })[0].lib; };
    // Aimés : les notes cochées d'abord, puis les « oui » aux odeurs.
    // Écartés : les types exclus, puis les « non » francs aux odeurs.
    // Chaque écart porte sa « cible » : les paliers s'en servent pour ne
    // jamais proposer ce qui a été refusé.
    var notes = this.choix ? this.choix.aimes : this.notesAimees;
    notes.forEach(function (k) { aimes.push({ k: k, lib: libDe(k), u: 2, groupe: k }); });
    var exclusions = this.choix ? EXCLUSIONS.filter(function (e) { return self.choix.evites.indexOf(e.k) >= 0; }) : this.exclusions;
    exclusions.forEach(function (e) { evites.push({ k: e.k, lib: e.lib, ico: e.ico, cible: e.cible, u: -2 }); });
    this.reponses.forEach(function (r) {
      var q = QUESTIONS.filter(function (x) { return x.id === r.id; })[0];
      if (!q) return;
      var g = q.cible[0][0].split('.');
      if (g[0] !== 'g') return;
      if (r.u >= 0.5 && !aimes.some(function (a) { return a.groupe === g[1]; })) aimes.push({ k: g[1], lib: libDe(g[1]), u: r.u, groupe: g[1] });
      if (r.u <= -0.5 && !evites.some(function (e) { return e.cible[0][0] === 'g.' + g[1]; })) evites.push({ k: g[1], lib: libDe(g[1]), groupe: g[1], cible: [['g.' + g[1], 1]], u: r.u });
    });
    aimes.sort(function (a, b) { return b.u - a.u; });

    // Les 3 familles olfactives (celles des fiches) des parfums en tête.
    var fam = {}, fw = 0;
    tete.forEach(function (i, rang) {
      var p = P[i], k = (w[i] + 1e-9) * (1 + (15 - rang) / 15);
      (p.familles || []).forEach(function (f, j) { fam[f] = (fam[f] || 0) + k * (j === 0 ? 1.3 : 1); fw += k; });
    });
    var familles = Object.keys(fam).map(function (f) { return { lib: f, v: fam[f] }; })
      .sort(function (a, b) { return b.v - a.v; }).slice(0, 3);
    var fmax = familles.length ? familles[0].v : 1;
    familles.forEach(function (f) { f.pct = Math.round(100 * f.v / fmax); });

    var dit = this.choix ? { moment: this.choix.moment, saison: this.choix.saison } : { moment: this.moment, saison: this.saison };
    var profil = {
      univers: univers,
      maison: univers[0],
      intensite: traits.presence < 0.4 ? 'Discrète' : traits.presence < 0.68 ? 'Remarquée' : 'Inoubliable',
      // Ce que le client a dit l'emporte sur ce qu'on déduit des parfums.
      moment: ({ soir: 'Plutôt le soir', jour: 'Plutôt la journée', les2: 'Jour et soir' })[dit.moment] ||
        (traits.soiree > 0.58 ? 'Plutôt le soir' : traits.soiree < 0.4 ? 'Plutôt la journée' : 'Jour et soir'),
      saison: ({ chaud: 'Saisons chaudes', froid: 'Saisons froides', annee: 'Toute l\'année' })[dit.saison] ||
        (traits.ete - traits.hiver > 0.15 ? 'Saisons chaudes' : traits.hiver - traits.ete > 0.15 ? 'Saisons froides' : 'Toute l\'année'),
      aimes: aimes.slice(0, 4),
      evites: evites,
      familles: familles
    };

    return { confiance: conf, top: cinq, profil: profil, paliers: this.paliers(profil, top, evites, filtre) };
  };

  Moteur.prototype.pourquoi = function (p) {
    var lib = {}; this.meta.univers.forEach(function (u) { lib[u.k] = u.lib; });
    var u = Object.keys(p.u).sort(function (a, b) { return p.u[b] - p.u[a]; }).filter(function (k) { return p.u[k] >= 0.45; }).slice(0, 2);
    var bouts = [];
    u.forEach(function (k) { bouts.push(lib[k]); });
    if (p.t.presence !== null) bouts.push(p.t.presence >= 0.68 ? 'Présence inoubliable' : p.t.presence >= 0.4 ? 'Présence remarquée' : 'Présence discrète');
    bouts.push(p.t.soiree >= 0.6 ? 'Idéal le soir' : p.t.soiree <= 0.3 ? 'Parfait au quotidien' : 'Jour comme soir');
    return bouts.join(' · ');
  };

  // ─── Sortir de sa zone de confort, pas à pas ─────────────────────────────
  Moteur.prototype.paliers = function (profil, top, evites, filtre) {
    var P = this.parfums, self = this;
    var maison = profil.univers[0].k, iM = CERCLE.indexOf(maison);
    var interdit = {}; top.forEach(function (i) { interdit[i] = true; });
    for (var ex in this.exclus) interdit[ex] = true;
    function dist(k) { var d = Math.abs(CERCLE.indexOf(k) - iM); return Math.min(d, CERCLE.length - d); }
    function dominant(p) { return Object.keys(p.u).sort(function (a, b) { return p.u[b] - p.u[a]; })[0]; }
    function deplait(p) { return evites.some(function (e) { var x = valeur(p, e); return x !== null && x > 0.55; }); }
    var lib = {}; this.meta.univers.forEach(function (u) { lib[u.k] = u.lib; });
    var defs = [
      { n: 1, titre: 'Un pas de côté', d: [1], garde: 0.35 },
      { n: 2, titre: 'Nouvel horizon', d: [2], garde: 0 },
      { n: 3, titre: 'L\'audace', d: [3, 4], garde: 0 }
    ];
    var ordre = this.classement();
    return defs.map(function (def) {
      for (var j = 0; j < ordre.length; j++) {
        var i = ordre[j], p = P[i];
        if (interdit[i] || !filtre(p) || p.qualite < 0.6 || deplait(p)) continue;
        var dom = dominant(p);
        if (def.d.indexOf(dist(dom)) < 0) continue;
        if ((p.u[maison] || 0) < def.garde) continue;
        interdit[i] = true;
        var texte = def.n === 1
          ? 'Votre univers « ' + lib[maison] + ' », avec une touche « ' + lib[dom] + ' ».'
          : def.n === 2
            ? 'Un univers voisin du vôtre : « ' + lib[dom] + ' ».'
            : 'À l\'opposé de vos habitudes : « ' + lib[dom] + ' ». Osez !';
        return { palier: def.n, titre: def.titre, parfum: p, i: i, univers: lib[dom], texte: texte };
      }
      return null;
    }).filter(Boolean);
  };

  // ─── LA VERSION EXPRESS : 7 questions fixes ─────────────────────────────
  // Les grandes notes proposées selon l'univers choisi.
  var UNIV_GROUPES = {
    frais: ['agrumes', 'aquatique', 'vert', 'aromatique', 'epices_fraiches'],
    fruite: ['fruits', 'agrumes', 'fleurs_blanches'],
    floral: ['rose', 'fleurs_blanches', 'poudre', 'fruits'],
    poudre: ['poudre', 'musc', 'rose', 'vanille'],
    gourmand: ['gourmand', 'vanille', 'fruits', 'ambre'],
    oriental: ['ambre', 'epices_chaudes', 'vanille', 'oud', 'rose'],
    sombre: ['cuir', 'oud', 'encens', 'tabac', 'bois'],
    boise: ['bois', 'santal', 'patchouli', 'encens', 'oud']
  };
  /* choix = { genre: 1 | 0 | -1, univers: [clés], aimes: [grandes notes],
     evites: [grandes notes], ref: index | null, moment: 'jour' | 'soir' | 'les2',
     saison: 'chaud' | 'froid' | 'annee', presence: 'discrete' | 'remarquee' | 'inoubliable' }
     Poids : univers 30 · notes 25 · parfum aimé 20 · présence 10 · moment et
     saison 10 · style 5. Sans parfum aimé, sa part se répartit sur le reste. */
  Moteur.prototype.express = function (choix) {
    this.reset();
    this.choix = choix;
    var P = this.parfums, self = this;
    var cles = this.meta.groupes.map(function (g) { return g.k; });
    var ref = choix.ref === null || choix.ref === undefined ? null : P[choix.ref];
    function vec(p) { return cles.map(function (k) { return p.g[k] || 0; }); }
    function cos(a, b) {
      var s = 0, na = 0, nb = 0;
      for (var i = 0; i < a.length; i++) { s += a[i] * b[i]; na += a[i] * a[i]; nb += b[i] * b[i]; }
      return na && nb ? s / Math.sqrt(na * nb) : 0;
    }
    var vRef = ref ? vec(ref) : null;
    var cible = { discrete: 0.2, remarquee: 0.55, inoubliable: 0.85 }[choix.presence];
    var W = { u: 30, n: 25, r: ref ? 20 : 0, p: 10, m: 10, g: 5 };
    this.logit = P.map(function (p, i) {
      if (ref && p === ref) return -50;
      var t = p.t, sc = 0, sw = 0;
      function ajoute(w, v) { if (v === null || v === undefined || !w) return; sc += w * v; sw += w; }
      if (choix.univers.length) ajoute(W.u, choix.univers.reduce(function (s, k) { return s + (p.u[k] || 0); }, 0) / choix.univers.length);
      if (choix.aimes.length) ajoute(W.n, choix.aimes.reduce(function (s, k) { return s + (p.g[k] || 0); }, 0) / choix.aimes.length);
      if (ref) ajoute(W.r, cos(vRef, vec(p)));
      if (cible !== undefined) ajoute(W.p, t.presence === null ? null : 1 - Math.abs(cible - t.presence));
      var m = choix.moment === 'soir' ? t.soiree : choix.moment === 'jour' ? 1 - t.soiree : choix.moment === 'les2' ? 1 - Math.abs(0.5 - t.soiree) : null;
      var s = choix.saison === 'chaud' ? t.ete : choix.saison === 'froid' ? t.hiver : choix.saison === 'annee' ? 1 - Math.abs(t.ete - t.hiver) : null;
      if (m !== null && s !== null) ajoute(W.m, (m + s) / 2); else ajoute(W.m, m !== null ? m : s);
      if (choix.genre) ajoute(W.g, choix.genre > 0 ? (t.genre + 1) / 2 : (1 - t.genre) / 2);
      var score = sw ? sc / sw : 0;
      var penalite = 0;
      EXCLUSIONS.forEach(function (e) {
        if (choix.evites.indexOf(e.k) < 0) return;
        var x = valeur(p, e);
        if (x !== null && x > 0.45) penalite += (x - 0.45) / 0.55;
      });
      return 9 * score - 4 * penalite + 1.2 * (p.qualite - 1);
    });
    return this.resultat();
  };

  var API = { Moteur: Moteur, QUESTIONS: QUESTIONS, REPONSES: REPONSES, CERCLE: CERCLE, valeur: valeur, UNIV_GROUPES: UNIV_GROUPES, EXCLUSIONS: EXCLUSIONS };
  if (typeof module !== 'undefined' && module.exports) module.exports = API;
  else racine.PdpTest = API;
})(this);

/* ═══ icones.js ═══ */
/* Icônes du test olfactif : traits fins, 24 × 24, couleur du texte.
   Une par question, une par univers. Dessinées pour le test. */
window.PDP_ICONES = (function () {
  var I = {
    // Odeurs du quotidien
    agrumes: '<circle cx="12" cy="13" r="7.5"/><path d="M12 5.5v15M4.5 13h15M6.7 7.7l10.6 10.6M17.3 7.7 6.7 18.3"/><path d="M12 5.5c0-2 1.5-3 3.5-3"/>',
    mer: '<path d="M2 9c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2 2.5 2 5 2"/><path d="M2 14c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2 2.5 2 5 2"/><path d="M2 19c2.5 0 2.5-2 5-2s2.5 2 5 2 2.5-2 5-2 2.5 2 5 2"/>',
    vert: '<path d="M5 19C5 10 11 4 20 4c0 9-6 15-15 15Z"/><path d="M5 19 14 10"/>',
    lavande: '<path d="M12 22V9"/><ellipse cx="12" cy="4" rx="1.6" ry="2"/><ellipse cx="9.8" cy="7.2" rx="1.5" ry="1.9"/><ellipse cx="14.2" cy="7.2" rx="1.5" ry="1.9"/><ellipse cx="10" cy="10.6" rx="1.4" ry="1.8"/><ellipse cx="14" cy="10.6" rx="1.4" ry="1.8"/><path d="M12 17c-2-1-4-1-5 0"/>',
    gingembre: '<path d="M4 15c0-3 2-5 5-5 1 0 1.5-2 3.5-2S15 10 17 10s3 2 3 4-2 4-4 4H8c-2.5 0-4-1-4-3Z"/><path d="M12.5 8V5M9 10 7.5 7"/>',
    rose: '<path d="M12 21v-7"/><path d="M12 14c-3.5 0-6-2.5-6-6 2 0 3 .5 4 1.5C10.5 6 11 4 12 3c1 1 1.5 3 2 6.5 1-1 2-1.5 4-1.5 0 3.5-2.5 6-6 6Z"/><path d="M12 18c-1.5-1.5-3.5-2-5-1.5"/>',
    jasmin: '<circle cx="12" cy="12" r="1.8"/><path d="M12 10.2C11 7 11 4.5 12 3c1 1.5 1 4 0 7.2ZM13.7 11.4c3-1.2 5.5-1.2 7 0-1.5 1.2-4 1.2-7 0ZM13 13.6c1.9 2.7 2.6 5.1 1.9 6.8-1.8-.6-2.9-3-1.9-6.8ZM11 13.6c-1.9 2.7-2.6 5.1-1.9 6.8 1.8-.6 2.9-3 1.9-6.8ZM10.3 11.4c-3-1.2-5.5-1.2-7 0 1.5 1.2 4 1.2 7 0Z"/>',
    poudre: '<circle cx="12" cy="14" r="7"/><circle cx="12" cy="14" r="4"/><path d="M8 4.5c1.5-1.5 6.5-1.5 8 0"/><circle cx="12" cy="14" r=".6"/>',
    linge: '<path d="M2 5h20"/><path d="M6 5v3l-2 2v9h7v-9L9 8V5M15 5v3l-2 2v9h7v-9l-2-2V5"/>',
    fruits: '<circle cx="8" cy="16" r="4"/><circle cx="16.5" cy="15" r="4"/><path d="M8 12c0-4 2-7 5-9M16.5 11c0-3-1.5-6-3.5-8"/><path d="M13 3c2 0 3.5 1 4 2.5"/>',
    patisserie: '<path d="M4 15c0-4.5 3.6-8 8-8s8 3.5 8 8H4Z"/><path d="M3 15h18l-1.5 5h-15L3 15Z"/><path d="M9 7.5c.5 1.5 1.5 3 3 7.5M15 7.5c-.5 1.5-1.5 3-3 7.5"/>',
    vanille: '<path d="M6 21c3-6 6-12 12-18"/><path d="M8.5 21c3-5.5 6-11 11.5-17"/><path d="M5 9c2 0 3 1 3 3M3 6c2 0 3.5 1 3.5 3"/>',
    souk: '<path d="M4 20h16"/><path d="M6 20c0-4 2.5-6 6-6s6 2 6 6"/><path d="M12 14V7"/><path d="M9 10c1-2 2-3 3-3s2 1 3 3"/><circle cx="12" cy="4.5" r="1.3"/>',
    ambre: '<path d="M12 2.5C9 7 6 10.5 6 14a6 6 0 0 0 12 0c0-3.5-3-7-6-11.5Z"/><path d="M9.5 15a2.5 2.5 0 0 0 2.5 2.5"/>',
    crayon: '<path d="M15.5 4.5 19.5 8.5 8 20H4v-4L15.5 4.5Z"/><path d="M13 7l4 4"/><path d="M4 16l4 4"/>',
    santal: '<rect x="3" y="9" width="18" height="7" rx="3.5"/><ellipse cx="18" cy="12.5" rx="1.8" ry="3.5"/><path d="M6 12.5h7"/>',
    foret: '<path d="M12 3 6 12h3l-4 6h14l-4-6h3L12 3Z"/><path d="M12 18v3"/>',
    oud: '<path d="M4 17 14 5l6 3-9 12-7-3Z"/><path d="M9 11.5l5 2.5M7 14.5l3.5 1.6"/>',
    feu: '<path d="M12 21c-4 0-6.5-2.6-6.5-6 0-4 3.5-5.5 4-10 3 2 4 4.5 4 7 1-1 1.5-2.5 1.5-3.5 2 1.5 3.5 4 3.5 6.5 0 3.4-2.5 6-6.5 6Z"/><path d="M12 21c-1.8 0-3-1.2-3-3 0-2 2-3 3-5 1 2 3 3 3 5 0 1.8-1.2 3-3 3Z"/>',
    cuir: '<path d="M8 3h8l4 4v14h-4.5L12 17l-3.5 4H4V7l4-4Z"/><path d="M8 3l4 6 4-6M12 9v8"/>',
    tabac: '<rect x="2.5" y="12" width="19" height="4" rx="2"/><path d="M17 12v4"/><path d="M19 9c0-1.5 1-2 1-3.5M16 9c0-1.5 1-2 1-3.5"/>',
    mineral: '<path d="M4 16 8 8l6-3 6 5-2 8-9 2-5-4Z"/><path d="M8 8l3 6 7 4M11 14l-7 2M14 5l-3 9"/>',
    // Envies
    sucre: '<path d="M7 12a5 5 0 1 0 10 0 5 5 0 0 0-10 0Z"/><path d="M7 12 3 9v6l4-3ZM17 12l4-3v6l-4-3Z"/><path d="M10 9.5c1 1.5 3 3.5 4 5"/>',
    cocon: '<path d="M7 4h10l4 5-3 2v9H6v-9L3 9l4-5Z"/><path d="M9.5 4a2.5 2.5 0 0 0 5 0"/><path d="M6 15h12M6 18h12"/>',
    reveil: '<path d="M5 6h7a3 3 0 0 1 3 3v1"/><circle cx="15" cy="12" r="2"/><path d="M12 16v1M15 16v2M18 16v1M13.5 20v1M16.5 20v1"/>',
    presence: '<circle cx="12" cy="12" r="2"/><path d="M8 8a5.7 5.7 0 0 0 0 8M16 8a5.7 5.7 0 0 1 0 8M5 5a10 10 0 0 0 0 14M19 5a10 10 0 0 1 0 14"/>',
    tenue: '<circle cx="12" cy="13" r="8"/><path d="M12 9v4l3 2M9 2h6"/>',
    soiree: '<path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z"/><path d="M17 3v3M15.5 4.5h3"/>',
    ete: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"/>',
    hiver: '<path d="M12 2v20M3.3 7l17.4 10M3.3 17 20.7 7"/><path d="M9.5 3.5 12 6l2.5-2.5M9.5 20.5 12 18l2.5 2.5M3.5 10.5 6.5 9l-1-3.2M20.5 13.5 17.5 15l1 3.2M3.5 13.5 6.5 15l-1 3.2M20.5 10.5 17.5 9l1-3.2"/>',
    genre: '<circle cx="9" cy="10" r="5"/><path d="M9 15v6M6.5 18.5h5"/><circle cx="15" cy="10" r="5"/><path d="M18.5 6.5 21.5 3.5M18 3.5h3.5V7"/>',
    // Version express
    univers: '<circle cx="12" cy="12" r="9"/><path d="M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18M3 12h18"/>',
    coeur: '<path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.6 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10Z"/>',
    evites: '<circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/>',
    flacon: '<path d="M9 2h6v3H9zM10 5v2.5L6 10v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V10l-4-2.5V5"/><path d="M6 14h12"/>',
    moment: '<circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 0 0 18Z" fill="currentColor" fill-opacity=".15"/>'
  };
  // Les univers reprennent l'icône de leur odeur emblématique.
  var U = { frais: 'agrumes', fruite: 'fruits', floral: 'rose', poudre: 'poudre', gourmand: 'patisserie', oriental: 'ambre', sombre: 'feu', boise: 'foret' };
  function svg(cle, taille) {
    var d = I[cle] || I[U[cle]] || I.flacon;
    return '<svg viewBox="0 0 24 24" width="' + (taille || 24) + '" height="' + (taille || 24) + '" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>';
  }
  return { svg: svg, univers: function (k, t) { return svg(U[k], t); } };
})();

/* ═══ app_shopify.js ═══ */
/* Perle de Parfum — le test olfactif sur le site (section « pdp-test-olfactif »).
 * Le catalogue est construit à partir des fiches écrites par la section
 * (« PdpTestCatalogue »), le moteur décide des questions (« PdpTest »), les
 * icônes viennent de « PDP_ICONES ». Ce fichier fait l'écran. */
(function () {
  'use strict';
  var T = window.PdpTest, ICO = window.PDP_ICONES;

  function lancer(racine, CAT) {
  var app = racine.querySelector('[data-pdp-test-app]');
  var TXT = {
    surtitre: racine.getAttribute('data-surtitre') || 'Test olfactif',
    titre: racine.getAttribute('data-titre') || 'Dites-nous ce que vous aimez sentir. Nous trouvons vos parfums.',
    intro: racine.getAttribute('data-intro') || ''
  };
  /* Chaque écran NEUF (question suivante) : si son haut (la jauge, la
     question) est caché — sous le header collant ou au-dessus de l'écran —,
     on le ramène juste sous le header. Le MÊME écran redessiné après un
     choix (« meme ») ne bouge pas et ne rejoue pas ses animations. */
  var meme = false, garde = false;
  function hauteurHeader() {
    var h = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header, header.header');
    if (!h) return 0;
    var st = getComputedStyle(h.closest('.shopify-section') || h);
    var colle = /sticky|fixed/.test(st.position) || /sticky|fixed/.test(getComputedStyle(h).position);
    return colle ? Math.max(0, h.getBoundingClientRect().height) : 0;
  }
  new MutationObserver(function () {
    if (meme) {
      meme = false;
      app.querySelectorAll('.anim-entree').forEach(function (e) { e.classList.remove('anim-entree'); });
      return;
    }
    if (garde) return; garde = true;
    requestAnimationFrame(function () {
      garde = false;
      var haut = app.getBoundingClientRect().top, h = hauteurHeader();
      if (haut < h + 8) window.scrollBy({ top: haut - h - 16, behavior: 'instant' });
    });
  }).observe(app, { childList: true });
  function redessiner(f) { meme = true; f(); }

  // L'icône d'une grande note : celle de la question qui la mesure.
  var ICO_GROUPE = { agrumes: 'agrumes', aromatique: 'lavande', epices_fraiches: 'gingembre', epices_chaudes: 'souk', rose: 'rose', fleurs_blanches: 'jasmin', poudre: 'poudre', fruits: 'fruits', gourmand: 'patisserie', vanille: 'vanille', ambre: 'ambre', musc: 'linge', santal: 'santal', bois: 'crayon', patchouli: 'foret', oud: 'oud', encens: 'feu', cuir: 'cuir', tabac: 'tabac', aquatique: 'mer', vert: 'vert', mineral: 'mineral' };
  // Les familles olfactives des fiches → une icône.
  var ICO_FAMILLE = { 'Floral': 'rose', 'Oriental': 'souk', 'Poudré': 'poudre', 'Musqué': 'linge', 'Cuiré': 'cuir', 'Fruité': 'fruits', 'Ambré': 'ambre', 'Boisé': 'crayon', 'Épicé': 'souk', 'Gourmand': 'patisserie', 'Aromatique': 'lavande', 'Hespéridé': 'agrumes', 'Aldéhydé': 'linge', 'Aquatique': 'mer', 'Chypré': 'foret', 'Fougère': 'lavande', 'Vert': 'vert' };
  var UNIV_TXT = {
    frais: 'Agrumes, air marin, herbes', fruite: 'Fruits juteux, pétillants', floral: 'Rose, jasmin, fleurs blanches',
    poudre: 'Iris, muscs, douceur propre', gourmand: 'Vanille, caramel, café', oriental: 'Ambre, épices, résines',
    sombre: 'Cuir, oud, encens, tabac', boise: 'Cèdre, santal, patchouli'
  };
  // Ce que regroupe chaque branche du graphique (familles des fiches produit).
  var GROUPE_AXE = {
    frais: 'Hespéridé, aromatique, aquatique, vert, fougère',
    poudre: 'Poudré, musqué, aldéhydé',
    oriental: 'Oriental, ambré, épicé',
    sombre: 'Cuir, oud, encens, tabac',
    boise: 'Boisé, chypré, patchouli'
  };
  var COURT = { frais: 'Frais', fruite: 'Fruité', floral: 'Floral', poudre: 'Poudré', gourmand: 'Gourmand', oriental: 'Oriental', sombre: 'Intense', boise: 'Boisé' };

  var etat = { mode: null, enLigne: false, moteur: null, journal: [], reglages: null, express: null, plus: [], affiches: null, profil: null, remplaces: {}, rejets: [], cartesPretes: {} };

  // ─── Le résultat reste enregistré ────────────────────────────────────
  /* Sur cet appareil (« localStorage »), on garde les réponses, pas le
     résultat : au retour, le moteur les rejoue sur le catalogue du moment.
     Un parfum épuisé entre-temps est donc remplacé tout seul. Seul
     « Refaire le test » efface. Plus tard, la même trace pourra être
     recopiée dans le compte client. */
  var CLE_SAUVE = 'pdp-test-olfactif';
  function cleP(p) { return p && p.produit ? p.produit.h : null; }
  function parCle(h) {
    if (!h) return null;
    for (var i = 0; i < CAT.parfums.length; i++) if (cleP(CAT.parfums[i]) === h) return CAT.parfums[i];
    return null;
  }
  function trace() {
    var E = etat.express, x = null;
    if (E) { x = {}; for (var c in E) x[c] = E[c]; x.ref = cleP(E.ref); }
    return {
      v: 1, date: Date.now(), mode: etat.mode, reglages: etat.reglages,
      journal: etat.journal.map(function (a) { return a.t === 'ref' ? { t: 'ref', h: cleP(a.p) } : a; }),
      express: x, plus: etat.plus, rejets: etat.rejets
    };
  }
  function lireLocal() {
    try { var S = JSON.parse(localStorage.getItem(CLE_SAUVE) || 'null'); return S && S.v === 1 && S.mode ? S : null; } catch (e) { return null; }
  }
  function sauver(S) {
    // Une trace qu'on vient de relire garde sa date : c'est elle qui départage
    // l'appareil et le compte.
    if (etat.sansEnvoi) return;
    S = S || trace();
    try { localStorage.setItem(CLE_SAUVE, JSON.stringify(S)); } catch (e) {}
    envoyerCompte(S);
  }
  function oublier() {
    var t = Date.now();
    try { localStorage.removeItem(CLE_SAUVE); localStorage.setItem(CLE_SAUVE + '-efface', String(t)); } catch (e) {}
    // Le profil du compte n'est PAS effacé : il reste jusqu'à ce que le nouveau
    // test soit fini (et le remplace). Seul cet appareil repart de zéro.
  }
  function restaurer() {
    var S = lireLocal();
    return S ? appliquer(S) : false;
  }
  // Rejoue une trace (de l'appareil ou du compte) jusqu'au résultat.
  // « silencieux » : on rejoue sans redessiner la page (avis retiré sur place).
  function appliquer(S, silencieux) {
    try {
      etat.mode = S.mode; etat.reglages = S.reglages || null; etat.plus = [];
      if (S.mode === 'adaptatif') {
        etat.journal = (S.journal || []).map(function (a) { return a.t === 'ref' ? { t: 'ref', p: parCle(a.h) } : a; });
        rejouer();
      } else {
        var E = S.express; E.ref = parCle(E.ref); etat.express = E;
        construireExpress();
        var m = etat.moteur;
        if (etat.reglages) { m.MAX = etat.reglages.MAX; m.MIN = etat.reglages.MIN; m.SEUIL = etat.reglages.SEUIL; }
        (S.plus || []).forEach(function (q) { m.repondre(q.id, q.u); etat.plus.push(q); });
      }
      calculerResultat();
      (S.rejets || []).forEach(function (r) {
        var i = -1;
        if (r.h) { var p = parCle(r.h); i = p ? CAT.parfums.indexOf(p) : -1; }
        else if (typeof r.k === 'number' && etat.affiches[r.k]) i = etat.affiches[r.k].i;
        if (i >= 0) ecarter(i, r.raison);
      });
      etat.frais = [];
      if (silencieux) return true;
      etat.sansEnvoi = true; // ce qu'on vient de relire n'a pas à repartir au compte
      vueResultat();
      etat.sansEnvoi = false;
      return true;
    } catch (e) { try { localStorage.removeItem(CLE_SAUVE); } catch (e2) {} return false; }
  }

  // ─── Le compte client (« pdp-compte ») ───────────────────────────────
  /* Client connecté : son profil s'enregistre seul dans son compte, et
     revient sur n'importe quel appareil. Ses achats comptent : un flacon
     acheté = « je l'ai déjà » ; un décant seulement = il le connaît, il sort
     de la sélection et passe dans « Vous l'avez testé : adoptez-le en flacon ». */
  var COMPTE = window.pdpCompte || null;
  etat.compte = null;
  etat.achats = { flacons: {}, decants: {} };
  etat.testes = [];
  function estFormatDecant(vt) {
    var m = /^\s*(\d+(?:[.,]\d+)?)\s*ml\b/i.exec(vt || '');
    return !!m && parseFloat(m[1].replace(',', '.')) <= 10;
  }
  function lireAchats(achats) {
    var parH = {}, A = { flacons: {}, decants: {} };
    CAT.parfums.forEach(function (p, i) { (p.hs || []).forEach(function (x) { parH[x.h] = { i: i, d: x.d }; }); });
    (achats || []).forEach(function (a) {
      var x = parH[a.h];
      if (!x) return;
      // Le 50 ml est une variante de la fiche décant : c'est le format qui décide.
      if (x.d && estFormatDecant(a.vt)) A.decants[x.i] = true; else A.flacons[x.i] = true;
    });
    for (var i in A.flacons) delete A.decants[i];
    return A;
  }
  function appliquerAchats(m) {
    if (m._achats) return;
    m._achats = true;
    Object.keys(etat.achats.flacons).forEach(function (i) { m.rejeter(+i, 'deja'); });
    Object.keys(etat.achats.decants).forEach(function (i) { m.exclus[+i] = true; });
    etat.testes = Object.keys(etat.achats.decants).map(Number);
  }
  /* Pour « Mon espace parfum » : la sélection qu'on aurait sans tel avis
     (ou sans aucun). L'espace s'en sert quand le client retire un avis : sa
     sélection se met à jour sur place, sans attendre sa visite du test. */
  var GARDES = ['mode', 'reglages', 'plus', 'journal', 'express', 'moteur', 'profil', 'affiches', 'paliers', 'confiance', 'remplaces', 'rejets', 'frais', 'testes'];
  function selectionSans(S, garder) {
    var sauve = {};
    GARDES.forEach(function (k) { sauve[k] = etat[k]; });
    var T2 = JSON.parse(JSON.stringify(S));
    T2.rejets = (T2.rejets || []).filter(garder);
    var l = null;
    try { if (appliquer(T2, true)) l = etat.affiches.map(function (t) { return { h: t.parfum.produit.h, nom: t.parfum.nom, maison: t.parfum.maison, pct: t.pct }; }); } catch (e) {}
    GARDES.forEach(function (k) { etat[k] = sauve[k]; });
    return l;
  }
  function variantes() {
    var S = trace(), o = {}, rj = (S.rejets || []).slice(0, 8);
    if (!rj.length) return null;
    rj.forEach(function (r) { o[r.h] = selectionSans(S, function (x) { return x.h !== r.h; }); });
    return { parAvis: o, sansAucun: selectionSans(S, function () { return false; }) };
  }
  function resume() {
    var pr = etat.profil, u0 = pr.univers[0];
    return {
      sansAvis: variantes(),
      date: Date.now(), maison: pr.maison.lib, familleCle: u0 && u0.k, familleLib: u0 && COURT[u0.k],
      familles: pr.univers.slice(0, 3).map(function (u) { return { k: u.k, lib: COURT[u.k], pct: u.pct, groupe: GROUPE_AXE[u.k] || '' }; }),
      intensite: pr.intensite, moment: pr.moment, saison: pr.saison,
      aimes: pr.aimes.map(function (a) { return a.lib; }), evites: pr.evites.map(function (a) { return a.lib; }),
      selection: etat.affiches.map(function (t) { return { h: t.parfum.produit.h, nom: t.parfum.nom, maison: t.parfum.maison, pct: t.pct }; }),
      toile: toile(),
      avis: etat.rejets.map(function (r) { var p = parCle(r.h); return { h: r.h, nom: p ? p.nom : r.h, maison: p ? p.maison : '', raison: r.raison }; }),
      testes: etat.testes.map(function (i) { var p = CAT.parfums[i]; return { h: p.produit.h, nom: p.nom, maison: p.maison, hf: p.flacon ? p.flacon.h : null }; }),
      page: location.pathname
    };
  }
  // Le graphique en toile, pour « Mon espace parfum » : chaque branche, sa
  // valeur (0-1) et celle du parfum n° 1 (pointillé).
  function toile() {
    var val = {}, no1 = etat.affiches[0] && etat.affiches[0].parfum;
    etat.profil.univers.forEach(function (u) { val[u.k] = u.pct / 100; });
    var m1 = no1 ? Math.max.apply(null, T.CERCLE.map(function (k) { return no1.u[k] || 0; })) || 1 : 1;
    return {
      no1: no1 ? no1.nom : null,
      axes: T.CERCLE.map(function (k) {
        return { k: k, lib: COURT[k], v: Math.round(1000 * (val[k] || 0)) / 1000, n1: no1 ? Math.round(1000 * (no1.u[k] || 0) / m1) / 1000 : null, groupe: GROUPE_AXE[k] || '' };
      })
    };
  }
  // Ce qui, dans le résumé du compte, doit suivre le site.
  function cleResume(x) {
    return JSON.stringify([x.toile ? x.toile.axes.map(function (a) { return a.v; }).join() : '', (x.selection || []).map(function (y) { return y.h; }), (x.testes || []).map(function (y) { return y.h; }),
      Object.keys((x.sansAvis && x.sansAvis.parAvis) || {}).sort()]);
  }
  function envoyerCompte(S) {
    if (etat.sansEnvoi || !etat.profil || !etat.compte || !etat.compte.connecte) return;
    etat.envoi = 'cours'; majStatut();
    window.pdpCompte.enregistrer({ test: S, resume: resume() }).then(function (ok) {
      etat.envoi = ok ? 'ok' : 'erreur'; majStatut();
    });
  }
  function majStatut() {
    var z = app.querySelector('[data-pdp-compte]');
    if (!z) return;
    var d = etat.compte;
    if (!COMPTE || !d || d.absent) { z.hidden = true; return; }
    z.hidden = false;
    if (!d.connecte) {
      z.className = 'pdp-test__compte';
      z.innerHTML = '<div><b>Gardez votre profil</b><span>Retrouvez-le sur tous vos appareils, avec vos avis et vos favoris. Un code par email suffit, sans mot de passe.</span></div>' +
        '<a class="btn btn--clair" href="' + echap(COMPTE.urlConnexion()) + '">Enregistrer dans mon compte</a>';
      return;
    }
    z.className = 'pdp-test__compte pdp-test__compte--ok';
    z.innerHTML = etat.envoi === 'cours' ? '<span>Enregistrement dans votre espace…</span>'
      : etat.envoi === 'erreur' ? '<span>Votre profil n\'a pas pu être enregistré dans votre compte. Il reste gardé sur cet appareil.</span>'
      : '<span>' + ICO.svg('flacon', 16) + ' Enregistré dans votre espace parfum</span><a href="' + echap(COMPTE.urlEspace) + '">Voir mon espace</a>';
  }
  function compteArrive(d) {
    etat.compte = d;
    if (!d.connecte) { majStatut(); return; }
    var A = lireAchats(d.achats), changeAchats = Object.keys(A.flacons).length + Object.keys(A.decants).length > 0;
    etat.achats = A;
    var local = lireLocal(), cpt = d.espace && d.espace.test, efface = 0;
    try { efface = +localStorage.getItem(CLE_SAUVE + '-efface') || 0; } catch (e) {}
    var resultat = racine.classList.contains('pdp-test--resultat'), accueil = !!app.querySelector('#b-go');
    if (!resultat && !accueil) return; // test en cours : les achats compteront au résultat
    if (cpt && cpt.v === 1 && (!local || (cpt.date || 0) > (local.date || 0)) && (cpt.date || 0) > efface) {
      try { localStorage.setItem(CLE_SAUVE, JSON.stringify(cpt)); } catch (e) {}
      etat.envoi = 'ok';
      if (appliquer(cpt)) {
        var r2 = resume(), anc = (d.espace && d.espace.resume) || {};
        if (cleResume(r2) !== cleResume(anc)) window.pdpCompte.enregistrer({ resume: r2 });
        return;
      }
    }
    if (resultat && local) {
      var aJour = cpt && (cpt.date || 0) >= (local.date || 0);
      etat.envoi = aJour ? 'ok' : null;
      if (changeAchats) appliquer(local);
      if (!aJour) envoyerCompte(local);
      else {
        // Les achats ont pu changer la sélection : le résumé du compte suit.
        var r = resume(), ancien = (d.espace && d.espace.resume) || {};
        if (cleResume(r) !== cleResume(ancien)) window.pdpCompte.enregistrer({ resume: r });
        majStatut();
      }
    }
  }

  function echap(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function icoGroupe(k, t) { return ICO.svg(ICO_GROUPE[k] || 'flacon', t || 16); }
  function libGroupe(k) { return CAT.meta.groupes.filter(function (g) { return g.k === k; })[0].lib; }
  function sousCatalogue() { return CAT; }
  function toast(t) {
    var d = document.createElement('div'); d.className = 'toast'; d.setAttribute('role', 'status'); d.textContent = t;
    racine.appendChild(d); setTimeout(function () { d.remove(); }, 3800);
  }
  function jauge(texteGauche, pct) {
    return '<div class="jauge"><div class="jauge-haut"><span>' + texteGauche + '</span><span>' + pct + ' %</span></div>' +
      '<div class="jauge-piste"><span style="width:' + pct + '%"></span></div></div>';
  }
  function entete(ico, titre, aide, facultatif) {
    return '<div class="question" style="min-height:0"><div class="medaillon">' + ICO.svg(ico, 40) + '</div><h2>' + echap(titre) +
      (facultatif ? ' <span class="facultatif">Facultatif</span>' : '') + '</h2><p class="aide">' + echap(aide) + '</p></div>';
  }

  // ─── Accueil ─────────────────────────────────────────────────────────
  function vueIntro() {
    racine.classList.remove('pdp-test--resultat');
    app.innerHTML =
      '<section class="ecran anim-entree">' +
        '<p class="surtitre">' + echap(TXT.surtitre) + '</p>' +
        '<h1>' + echap(TXT.titre) + '</h1>' +
        (TXT.intro ? '<p class="intro-texte">' + echap(TXT.intro) + '</p>' : '') +
        '<div class="modes">' +
          '<button class="mode" id="b-go" type="button"><span class="mode-tete">' + ICO.svg('presence', 28) + '<em>Recommandée</em></span><b>Version adaptative</b><span>Chaque réponse choisit la question suivante. 10 à 18 questions, 2 à 3 minutes.</span></button>' +
          '<button class="mode" id="b-express" type="button"><span class="mode-tete">' + ICO.svg('tenue', 28) + '<em>Rapide</em></span><b>Version express</b><span>7 questions fixes : univers, notes, ce que vous évitez, moment, présence. Environ 1 minute.</span></button>' +
        '</div>' +
      '</section>';
    document.getElementById('b-go').onclick = demarrerAdaptatif;
    document.getElementById('b-express').onclick = demarrerExpress;
  }

  // ─── Écrans communs ──────────────────────────────────────────────────
  // Le parfum de référence : la seule question facultative.
  function ecranReference(o) {
    var choisi = o.valeur;
    app.innerHTML =
      '<section class="ecran">' + jauge(o.gauche, o.pct) +
        entete('flacon', 'Un parfum que vous aimez déjà ?', 'Nous partirons de lui pour vous trouver ses cousins. Vous pouvez passer cette question.', true) +
        '<div class="etape-choix">' +
          (choisi
            ? '<div class="choisi"><span><b>' + echap(choisi.nom) + '</b> · ' + echap(choisi.maison) + '</span><button class="lien-discret" type="button" id="r-retirer">Retirer</button></div>'
            : '<input class="champ" id="r-champ" type="search" autocomplete="off" placeholder="Nom ou maison, par exemple « Baccarat »" aria-label="Rechercher un parfum"><div class="suggestions" id="r-sugg" hidden></div>') +
        '</div>' +
        '<div class="bas-question"><button class="lien-discret" id="r-retour" type="button">← ' + (o.retourTexte || 'Accueil') + '</button>' +
          '<button class="btn" id="r-suite" type="button">' + (choisi ? 'Suivant' : 'Passer') + '</button></div>' +
      '</section>';
    var champ = document.getElementById('r-champ'), sugg = document.getElementById('r-sugg');
    if (champ) {
      champ.oninput = function () {
        var t = champ.value.trim().toLowerCase();
        if (t.length < 2) { sugg.hidden = true; return; }
        var res = sousCatalogue().parfums.filter(function (p) { return (p.nom + ' ' + p.maison).toLowerCase().indexOf(t) >= 0; }).slice(0, 8);
        sugg.hidden = !res.length;
        sugg.innerHTML = res.map(function (p, k) { return '<button type="button" data-k="' + k + '">' + echap(p.nom) + ' <small>· ' + echap(p.maison) + ' · ' + echap(p.conc) + '</small></button>'; }).join('');
        sugg.querySelectorAll('button').forEach(function (b) { b.onclick = function () { o.valeur = res[+b.getAttribute('data-k')]; redessiner(function () { ecranReference(o); }); }; });
      };
    }
    var rr = document.getElementById('r-retirer'); if (rr) rr.onclick = function () { o.valeur = null; redessiner(function () { ecranReference(o); }); };
    document.getElementById('r-retour').onclick = o.retour;
    document.getElementById('r-suite').onclick = function () { o.valider(o.valeur || null); };
  }

  /* Un choix multiple avec sa sortie « aucune » : on ne peut pas avancer sans
     répondre, mais on n'est jamais bloqué. */
  function ecranChoix(o) {
    // Jamais de présélection : on arrive sur l'écran, rien n'est coché.
    var sel = [], aucune = false;
    function rendu() {
      var pret = sel.length > 0 || aucune;
      app.innerHTML =
        '<section class="ecran">' + jauge(o.gauche, o.pct) + entete(o.ico, o.titre, o.aide, false) +
          '<div class="puces-choix' + (o.negatif ? ' non' : '') + '">' +
            o.options.map(function (op) { return '<button type="button" data-v="' + op.k + '" aria-pressed="' + (sel.indexOf(op.k) >= 0) + '">' + ICO.svg(op.ico, 16) + echap(op.lib) + '</button>'; }).join('') +
            '<button type="button" class="aucune" data-aucune aria-pressed="' + aucune + '">' + echap(o.aucuneLib) + '</button>' +
          '</div>' +
          '<div class="bas-question"><button class="lien-discret" id="c-retour" type="button">← Précédente</button>' +
            '<button class="btn" id="c-suite" type="button"' + (pret ? '' : ' disabled') + '>' +
              (aucune ? 'Valider' : sel.length === 1 ? 'Valider mon choix' + (o.max > 1 ? ' (1/' + o.max + ')' : '') : sel.length ? 'Valider mes ' + sel.length + ' choix' + (sel.length < o.max ? ' (' + sel.length + '/' + o.max + ')' : '') : 'Faites votre choix') + '</button></div>' +
        '</section>';
      sansFocus();
      app.querySelectorAll('[data-v]').forEach(function (b) {
        b.onclick = function () {
          var v = b.getAttribute('data-v'), i = sel.indexOf(v);
          if (i >= 0) sel.splice(i, 1); else { if (sel.length >= o.max) sel.shift(); sel.push(v); }
          aucune = false; redessiner(rendu);
        };
      });
      app.querySelector('[data-aucune]').onclick = function () { aucune = !aucune; if (aucune) sel = []; redessiner(rendu); };
      document.getElementById('c-retour').onclick = o.retour;
      document.getElementById('c-suite').onclick = function () { if (sel.length || aucune) o.valider(sel, aucune); };
    }
    rendu();
  }
  var OPTIONS_NOTES = function (cles) {
    return (cles || CAT.meta.groupes.map(function (g) { return g.k; })).map(function (k) { return { k: k, lib: libGroupe(k), ico: ICO_GROUPE[k] }; });
  };
  var OPTIONS_EXCLUS = function () { return T.EXCLUSIONS.map(function (e) { return { k: e.k, lib: e.lib, ico: e.ico }; }); };

  // ─── Version adaptative ──────────────────────────────────────────────
  /* Tout ce que le client a fait est noté dans un journal ; revenir en
     arrière, c'est rejouer le journal sans la dernière entrée. */
  function rejouer() {
    var c = sousCatalogue(), m = new T.Moteur(c);
    if (etat.reglages) { m.MAX = etat.reglages.MAX; m.MIN = etat.reglages.MIN; m.SEUIL = etat.reglages.SEUIL; }
    etat.journal.forEach(function (a) {
      if (a.t === 'ref') { if (a.p) m.parfumAime(c.parfums.indexOf(a.p)); }
      else if (a.t === 'q') m.repondre(a.id, a.u);
      else if (a.t === 'notes') m.aimerNotes(a.cles);
      else if (a.t === 'exclus') m.exclure(a.cles);
      else if (a.t === 'quand') m.quand(a.moment, a.saison);
    });
    etat.moteur = m;
    return m;
  }
  function demarrerAdaptatif() {
    etat.mode = 'adaptatif'; etat.journal = []; etat.reglages = null; etat.plus = []; etat.jaugeMax = 0; etat.jaugeN = undefined;
    etapeReference();
  }
  function etapeReference() {
    ecranReference({
      gauche: 'Avant de commencer', pct: 0, valeur: null,
      retour: vueIntro,
      valider: function (p) { etat.journal = [{ t: 'ref', p: p }]; rejouer(); suivante(); }
    });
  }
  function aFait(t) { return etat.journal.some(function (a) { return a.t === t; }); }
  function suivante() {
    var m = etat.moteur, n = m.reponses.length;
    if (etat.mode === 'adaptatif') {
      if (n === 3 && !aFait('notes')) return etapeNotes();
      if (n === 7 && !aFait('exclus')) return etapeExclus();
      // « Pour quand ? » : prêt, mais éteint. Mesuré sur le catalogue actuel,
      // il ne cible pas mieux (occasion et saison ne sont renseignées que sur
      // 27 % des fiches) : les questions soirée / été / hiver, posées seulement
      // quand elles départagent, font mieux. À rallumer quand les fiches
      // seront complétées.
      if (DEMANDER_QUAND && n === 9 && !aFait('quand')) return etapeQuand();
    }
    if (m.fini()) return penser();
    var q = m.prochaine();
    if (!q) return penser();
    vueQuestion(q);
  }
  function numero() { return etat.moteur.reponses.length + 1; }
  // Jamais 100 % avant la fin : la barre se remplit au résultat.
  /* La jauge : chaque réponse comble une part du chemin restant, selon le
     nombre de questions qu'il reste probablement (entre le minimum et le
     maximum, d'après la certitude du moteur). Elle avance donc pas à pas,
     ne recule jamais, et n'atteint 100 % qu'au résultat. */
  function pctJauge(m) {
    var n = m.reponses.length;
    if (etat.jaugeN === undefined) { etat.jaugeN = n; etat.jaugeMax = 0; return 0; }
    while (etat.jaugeN < n) {
      var k = etat.jaugeN + 1;
      var conf = Math.min(1, m.confiance() / m.SEUIL);
      // Combien de questions en tout, probablement : entre le minimum et le maximum.
      var total = Math.max(m.MIN, Math.min(m.MAX, Math.round(m.MIN + (m.MAX - m.MIN) * (1 - conf))));
      var restant = Math.max(1, total - k);
      etat.jaugeMax += (97 - etat.jaugeMax) / (restant + 1);
      etat.jaugeN = k;
    }
    // Recul (« Précédente ») : la jauge garde sa place.
    return Math.round(Math.min(97, etat.jaugeMax));
  }

  function etapeNotes() {
    var m = etat.moteur;
    ecranChoix({
      gauche: 'Question ' + numero(), pct: pctJauge(m), ico: 'coeur',
      titre: 'Les notes que vous adorez ?', aide: 'Jusqu\'à 3. Fiez-vous à votre instinct.',
      options: OPTIONS_NOTES(), max: 3, aucuneLib: 'Aucune en particulier',
      retour: retour,
      valider: function (sel) { etat.journal.push({ t: 'notes', cles: sel }); m.aimerNotes(sel); suivante(); }
    });
  }
  function etapeExclus() {
    var m = etat.moteur;
    ecranChoix({
      gauche: 'Question ' + numero(), pct: pctJauge(m), ico: 'evites', negatif: true,
      titre: 'Ce que vous voulez éviter ?', aide: 'Jusqu\'à 3. Nous ne vous proposerons pas un parfum où cela domine.',
      options: OPTIONS_EXCLUS(), max: 3, aucuneLib: 'Rien à exclure',
      retour: retour,
      valider: function (sel) { etat.journal.push({ t: 'exclus', cles: sel }); m.exclure(sel); suivante(); }
    });
  }
  // « Pour quand ? » : le moment ET la saison, les deux sont à choisir.
  function ecranQuand(o) {
    var moment = null, saison = null;
    function rendu() {
      var pret = moment !== null && saison !== null;
      app.innerHTML =
        '<section class="ecran">' + jauge(o.gauche, o.pct) + entete('moment', 'Pour quand ?', 'Le moment, puis la saison : choisissez les deux.', false) +
          '<div class="etape-choix"><p class="sous-titre">Le moment</p><div class="choix-grille">' + [['jour', 'Au quotidien', 'ete'], ['soir', 'Pour sortir', 'soiree'], ['les2', 'Les deux', 'moment']].map(function (x) {
            return '<button class="tuile tuile-ico" type="button" data-m="' + x[0] + '" aria-pressed="' + (moment === x[0]) + '">' + ICO.svg(x[2], 26) + '<b>' + x[1] + '</b></button>'; }).join('') + '</div>' +
          '<p class="sous-titre">La saison</p><div class="choix-grille">' + [['chaud', 'Saisons chaudes', 'ete'], ['froid', 'Saisons froides', 'hiver'], ['annee', 'Toute l\'année', 'moment']].map(function (x) {
            return '<button class="tuile tuile-ico" type="button" data-s="' + x[0] + '" aria-pressed="' + (saison === x[0]) + '">' + ICO.svg(x[2], 26) + '<b>' + x[1] + '</b></button>'; }).join('') + '</div></div>' +
          '<div class="bas-question"><button class="lien-discret" id="w-retour" type="button">← Précédente</button>' +
            '<button class="btn" id="w-suite" type="button"' + (pret ? '' : ' disabled') + '>' + (pret ? (o.dernier ? 'Voir mes résultats' : 'Suivant') : (moment === null && saison === null ? 'Choisissez le moment et la saison' : moment === null ? 'Choisissez le moment' : 'Choisissez la saison')) + '</button></div>' +
        '</section>';
      sansFocus();
      app.querySelectorAll('[data-m]').forEach(function (b) { b.onclick = function () { moment = b.getAttribute('data-m'); redessiner(rendu); }; });
      app.querySelectorAll('[data-s]').forEach(function (b) { b.onclick = function () { saison = b.getAttribute('data-s'); redessiner(rendu); }; });
      document.getElementById('w-retour').onclick = o.retour;
      document.getElementById('w-suite').onclick = function () { if (pret) o.valider(moment, saison); };
    }
    rendu();
  }
  function etapeQuand() {
    var m = etat.moteur;
    ecranQuand({ gauche: 'Question ' + numero(), pct: pctJauge(m), retour: retour,
      valider: function (mo, sa) { etat.journal.push({ t: 'quand', moment: mo, saison: sa }); m.quand(mo, sa); suivante(); } });
  }
  // Un écran neuf ne garde ni le focus ni la trace du toucher précédent.
  function sansFocus() { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); }

  function vueQuestion(q) {
    var m = etat.moteur, reps = q.reponses || T.REPONSES, pct = pctJauge(m);
    var peutRevenir = etat.mode === 'adaptatif';
    app.innerHTML =
      '<section class="ecran">' + jauge('Question ' + numero() + ' · je cerne votre profil', pct) +
        '<div class="question"><div class="medaillon">' + ICO.svg(q.id, 40) + '</div><h2>' + echap(q.texte) + '</h2><p class="aide">' + echap(q.aide) + '</p></div>' +
        '<div class="reponses">' + reps.map(function (r, k) {
          var pos = Math.round((1 - (r[1] + 1) / 2) * 38);
          return '<button class="rep" type="button" data-k="' + k + '"><span>' + echap(r[0]) + '</span><span class="tiret" aria-hidden="true"><i style="left:' + pos + 'px"></i></span></button>';
        }).join('') + '</div>' +
        '<div class="bas-question">' + (peutRevenir ? '<button class="lien-discret" id="b-retour" type="button">← Précédente</button>' : '<span></span>') + '</div>' +
      '</section>';
    sansFocus();
    var parti = false, pretA = Date.now() + 400;
    app.querySelectorAll('.rep').forEach(function (b) {
      b.onclick = function () {
        if (parti || Date.now() < pretA) return; parti = true;
        // Le choix s'allume (contour ambré) un court instant, puis question suivante.
        b.classList.add('choisi'); b.setAttribute('aria-pressed', 'true');
        var u = reps[+b.getAttribute('data-k')][1];
        setTimeout(function () {
          if (etat.mode === 'adaptatif') etat.journal.push({ t: 'q', id: q.id, u: u });
          else etat.plus.push({ id: q.id, u: u });
          m.repondre(q.id, u); suivante();
        }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260);
      };
    });
    var r = document.getElementById('b-retour'); if (r) r.onclick = retour;
  }
  function retour() {
    etat.journal.pop();
    if (!etat.journal.length) return etapeReference();
    rejouer();
    var dernier = etat.journal[etat.journal.length - 1];
    if (dernier.t === 'ref' && etat.journal.length === 1) return suivante();
    suivante();
  }
  function penser() {
    app.innerHTML = '<section class="pensee anim-entree"><div class="goutte" aria-hidden="true"></div><p class="surtitre">Je réfléchis…</p><h2>J\'assemble votre profil olfactif</h2></section>';
    setTimeout(function () { calculerResultat(); vueResultat(); }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1100);
  }

  // ─── Version express : 7 questions fixes ────────────────────────────
  var DEMANDER_QUAND = false;
  var ETAPES_X = ['ref', 'genre', 'univers', 'aimes', 'evites', 'moment', 'presence'];
  function demarrerExpress() {
    etat.mode = 'express'; etat.reglages = null; etat.plus = [];
    etat.express = { etape: 0, ref: null, genre: null, univers: null, aimes: null, evites: null, moment: null, saison: null, presence: null };
    vueExpress();
  }
  function vueExpress() {
    var E = etat.express, et = ETAPES_X[E.etape], n = E.etape + 1;
    // Arrivée sur une étape (en avançant comme en revenant) : rien n'est
    // présélectionné, le client choisit lui-même.
    if (E.vu !== E.etape) {
      E.vu = E.etape;
      var vide = { ref: { ref: null }, genre: { genre: null }, univers: { univers: null }, aimes: { aimes: null }, evites: { evites: null }, moment: { moment: null, saison: null }, presence: { presence: null } }[et];
      for (var cle in vide) E[cle] = vide[cle];
    }
    var gauche = 'Express · question ' + n + ' sur ' + ETAPES_X.length, pct = Math.round(100 * E.etape / ETAPES_X.length);
    function avancer() { if (E.etape < ETAPES_X.length - 1) { E.etape++; vueExpress(); } else lancerExpress(); }
    function reculer() { if (E.etape === 0) vueIntro(); else { E.etape--; vueExpress(); } }
    if (et === 'ref') return ecranReference({ gauche: gauche, pct: pct, valeur: null, retour: reculer, valider: function (p) { E.ref = p; avancer(); } });
    if (et === 'aimes') {
      var off = [];
      (E.univers && E.univers.length ? E.univers : Object.keys(T.UNIV_GROUPES)).forEach(function (u) { T.UNIV_GROUPES[u].forEach(function (k) { if (off.indexOf(k) < 0) off.push(k); }); });
      return ecranChoix({ gauche: gauche, pct: pct, ico: 'coeur', titre: 'Les notes que vous adorez ?', aide: 'Jusqu\'à 3' + (E.univers && E.univers.length ? ', parmi celles de vos univers.' : '.'),
        options: OPTIONS_NOTES(off), max: 3, aucuneLib: 'Aucune en particulier',
        retour: reculer, valider: function (sel) { E.aimes = sel; avancer(); } });
    }
    if (et === 'evites') {
      return ecranChoix({ gauche: gauche, pct: pct, ico: 'evites', negatif: true, titre: 'Ce que vous voulez éviter ?', aide: 'Jusqu\'à 3. Nous ne vous proposerons pas un parfum où cela domine.',
        options: OPTIONS_EXCLUS(), max: 3, aucuneLib: 'Rien à exclure',
        retour: reculer, valider: function (sel) { E.evites = sel; avancer(); } });
    }
    if (et === 'moment') return ecranQuand({ gauche: gauche, pct: pct, retour: reculer, valider: function (mo, sa) { E.moment = mo; E.saison = sa; avancer(); } });
    var titre = '', aide = '', corps = '', pret = false, ico = { genre: 'genre', univers: 'univers', presence: 'presence' }[et];
    if (et === 'genre') {
      titre = 'Pour qui ?'; aide = 'Presque tous nos parfums sont unisexes : c\'est une préférence, pas un filtre.';
      corps = '<div class="choix-grille deux">' + [[1, 'Plutôt féminin'], [-1, 'Plutôt masculin'], [0, 'Les deux me vont']].map(function (o) {
        return '<button class="tuile" type="button" data-v="' + o[0] + '" aria-pressed="' + (E.genre === o[0]) + '"><b>' + o[1] + '</b></button>'; }).join('') + '</div>';
      pret = E.genre !== null;
    } else if (et === 'univers') {
      var u = E.univers || [];
      titre = 'Quels univers vous attirent ?'; aide = 'Un ou deux choix.';
      corps = '<div class="choix-grille">' + CAT.meta.univers.map(function (x) {
        return '<button class="tuile tuile-ico" type="button" data-v="' + x.k + '" aria-pressed="' + (u.indexOf(x.k) >= 0) + '">' + ICO.univers(x.k, 30) + '<b>' + echap(x.lib) + '</b><small>' + echap(UNIV_TXT[x.k]) + '</small></button>'; }).join('') +
        '<button class="tuile tuile-ico aucune" type="button" data-aucun aria-pressed="' + (E.univers !== null && !E.univers.length) + '">' + ICO.svg('univers', 30) + '<b>Je ne sais pas</b><small>Tous peuvent me plaire</small></button></div>';
      pret = E.univers !== null;
    } else if (et === 'presence') {
      titre = 'Quelle présence ?'; aide = 'Ce que les autres sentent de vous.';
      corps = '<div class="choix-grille">' + [['discrete', 'Discrète', 'Pour vous, de près'], ['remarquee', 'Remarquée', 'Qu\'on la sente en passant'], ['inoubliable', 'Inoubliable', 'Qu\'on s\'en souvienne']].map(function (o) {
        return '<button class="tuile" type="button" data-v="' + o[0] + '" aria-pressed="' + (E.presence === o[0]) + '"><b>' + o[1] + '</b><small>' + o[2] + '</small></button>'; }).join('') + '</div>';
      pret = E.presence !== null;
    }
    app.innerHTML =
      '<section class="ecran">' + jauge(gauche, pct) + entete(ico, titre, aide, false) +
        '<div class="etape-choix">' + corps + '</div>' +
        '<div class="bas-question"><button class="lien-discret" id="x-retour" type="button">← Précédente</button>' +
          '<button class="btn" id="x-suite" type="button"' + (pret ? '' : ' disabled') + '>' + (!pret ? 'Faites votre choix' : n === ETAPES_X.length ? 'Voir mes résultats' : 'Suivant') + '</button></div>' +
      '</section>';
    app.querySelectorAll('[data-v]').forEach(function (b) {
      b.onclick = function () {
        var v = b.getAttribute('data-v');
        if (et === 'genre') E.genre = +v;
        else if (et === 'univers') {
          var l = (E.univers || []).slice(), i = l.indexOf(v);
          if (i >= 0) l.splice(i, 1); else { if (l.length >= 2) l.shift(); l.push(v); }
          E.univers = l.length ? l : null;
          if (E.aimes) E.aimes = E.aimes.filter(function (k) { return l.some(function (x) { return T.UNIV_GROUPES[x].indexOf(k) >= 0; }); });
        } else if (et === 'presence') E.presence = v;
        redessiner(vueExpress);
      };
    });
    var ac = app.querySelector('[data-aucun]'); if (ac) ac.onclick = function () { E.univers = (E.univers && !E.univers.length) ? null : []; redessiner(vueExpress); };
    sansFocus();
    document.getElementById('x-retour').onclick = reculer;
    document.getElementById('x-suite').onclick = function () { if (pret) avancer(); };
  }
  function construireExpress() {
    var E = etat.express, c = sousCatalogue();
    etat.moteur = new T.Moteur(c);
    etat.moteur.express({ genre: E.genre, univers: E.univers || [], aimes: E.aimes || [], evites: E.evites || [], ref: E.ref ? c.parfums.indexOf(E.ref) : null, moment: E.moment, saison: E.saison, presence: E.presence });
  }
  function lancerExpress() { construireExpress(); penser(); }

  // ─── Résultat (sur le site) ──────────────────────────────────────────
  // Seuls les parfums disponibles sont recommandés.
  // Réglage « que des parfums en décant » : la sélection tient alors toujours
  // dans un coffret de 5 décants.
  var SEUL_DECANT = racine.getAttribute('data-seulement-decants') === 'true';
  function dispo(p) { return p.dispo && (!SEUL_DECANT || !!(p.decantFiche && p.decantFiche.ok)); }
  function calculerResultat() {
    appliquerAchats(etat.moteur);
    var r = etat.moteur.resultat({ filtre: dispo });
    etat.profil = r.profil;
    etat.affiches = r.top;
    etat.paliers = r.paliers;
    etat.confiance = r.confiance;
    etat.remplaces = {};
    etat.rejets = [];
  }
  function anneau(pct) {
    var c = 2 * Math.PI * 28, plein = c * pct / 100;
    return '<div class="anneau"><svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="28" fill="none" stroke="var(--sable)" stroke-width="4"></circle><circle cx="32" cy="32" r="28" fill="none" stroke="var(--or)" stroke-width="4" stroke-dasharray="' + plein.toFixed(1) + ' ' + c.toFixed(1) + '"></circle></svg><b>' + pct + '</b></div>';
  }
  // Le profil en toile d'araignée : un axe par univers, dans l'ordre du cercle
  // des parfums (voisins côte à côte). En pointillé, le parfum n° 1.
  function radar(univers, no1) {
    var cx = 210, cy = 190, R = 118, N = T.CERCLE.length, val = {};
    univers.forEach(function (u) { val[u.k] = u.pct / 100; });
    function pt(i, v) { var a = -Math.PI / 2 + i * 2 * Math.PI / N; return [cx + Math.cos(a) * R * v, cy + Math.sin(a) * R * v]; }
    function poly(f) { return T.CERCLE.map(function (k, i) { return pt(i, f(k)).map(function (x) { return x.toFixed(1); }).join(','); }).join(' '); }
    var svg = '<svg class="radar" viewBox="0 0 420 380" role="img" aria-label="Profil olfactif en toile">';
    [0.25, 0.5, 0.75, 1].forEach(function (v) { svg += '<polygon class="anneau-r" points="' + poly(function () { return v; }) + '"></polygon>'; });
    T.CERCLE.forEach(function (k, i) { var e = pt(i, 1); svg += '<line class="axe" x1="' + cx + '" y1="' + cy + '" x2="' + e[0].toFixed(1) + '" y2="' + e[1].toFixed(1) + '"></line>'; });
    if (no1) {
      var m1 = Math.max.apply(null, T.CERCLE.map(function (k) { return no1.u[k] || 0; })) || 1;
      svg += '<polygon class="no1" points="' + poly(function (k) { return Math.max(0.04, (no1.u[k] || 0) / m1); }) + '"></polygon>';
    }
    svg += '<polygon class="vous" points="' + poly(function (k) { return Math.max(0.04, val[k] || 0); }) + '"></polygon>';
    T.CERCLE.forEach(function (k, i) {
      var p = pt(i, Math.max(0.04, val[k] || 0)); svg += '<circle class="pt" cx="' + p[0].toFixed(1) + '" cy="' + p[1].toFixed(1) + '" r="3.2"></circle>';
      var l = pt(i, 1.2), a = Math.cos(-Math.PI / 2 + i * 2 * Math.PI / N);
      var anc = Math.abs(a) < 0.3 ? 'middle' : a > 0 ? 'start' : 'end';
      var dy = l[1] < cy - R * 0.9 ? -12 : l[1] > cy + R * 0.9 ? 12 : 0;
      svg += '<text x="' + l[0].toFixed(1) + '" y="' + (l[1] + dy).toFixed(1) + '" text-anchor="' + anc + '">' + COURT[k] + '</text>';
      svg += '<text class="val" x="' + l[0].toFixed(1) + '" y="' + (l[1] + dy + 16).toFixed(1) + '" text-anchor="' + anc + '">' + Math.round(100 * (val[k] || 0)) + '</text>';
    });
    return svg + '</svg>';
  }

  // ─── Les cartes du site ──────────────────────────────────────────────
  /* La carte de chaque parfum est la VRAIE carte du site (« pdp-carte »),
     demandée à Shopify comme le fait la page « Mes favoris » : cœur, aperçu,
     « + Panier », prix, tout fonctionne. Faute de réponse, une carte simple
     avec le lien vers la fiche. */
  var RACINE_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartes = {};
  function carteDe(p) {
    var h = p.produit.h;
    if (cartes[h]) return cartes[h];
    function essai(n) {
      return fetch(RACINE_URL + 'products/' + encodeURIComponent(h) + '?section_id=pdp-carte', { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) console.warn('[pdp-test] carte ' + h + ' : réponse ' + r.status + ' (essai ' + n + ')');
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          if (!html) return null;
          var li = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdp-handle]');
          // 200 mais sans carte : page de contrôle d'un réseau d'entreprise, d'un VPN…
          if (!li) console.warn('[pdp-test] carte ' + h + ' : réponse sans carte (essai ' + n + ')', html.slice(0, 200));
          return li ? li.outerHTML : null;
        })
        .catch(function () { return null; })
        .then(function (html) {
          // Shopify refuse parfois quand plusieurs cartes partent ensemble : on réessaie.
          if (html || n >= 3) return html;
          return new Promise(function (ok) { setTimeout(ok, 700 * n); }).then(function () { return essai(n + 1); });
        });
    }
    // Dernier recours : la fiche produit en JSON (photo, prix), servie par le CDN de Shopify.
    function fiche() {
      return fetch(RACINE_URL + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d ? secours(p, d) : null; })
        .catch(function () { return null; });
    }
    cartes[h] = essai(1).then(function (html) { return html || fiche(); }).then(function (html) { if (!html) delete cartes[h]; return html; });
    return cartes[h];
  }
  // Si la vraie carte ne vient pas : une carte simple, mais complète (prix, lien).
  function secours(p, d) {
    var ps = ((p.produit.var || []).filter(function (v) { return v.ok; }).map(function (v) { return v.p; }));
    var min = d && typeof d.price === 'number' ? d.price : ps.length ? Math.min.apply(null, ps) : null;
    var img = d && d.featured_image ? String(d.featured_image).replace(/^\/\//, 'https://') : '';
    if (img) img += (img.indexOf('?') < 0 ? '?' : '&') + 'width=600';
    return '<li data-pdp-handle="' + echap(p.produit.h) + '" class="pdp-test__secours"><div class="pdp-coll__carte"><a class="pdp-test__secours-visuel" href="' + echap(p.produit.u) + '" aria-hidden="true" tabindex="-1">' +
      (img ? '<img src="' + echap(img) + '" alt="" loading="lazy">' : ICO.svg('flacon', 44)) + '</a><div class="pdp-coll__corps-carte">' +
      '<span class="pdp-coll__marque">' + echap(p.maison) + '</span><a class="pdp-coll__nom-lien" href="' + echap(p.produit.u) + '"><span class="pdp-coll__nom">' + echap(p.nom) + '</span></a>' +
      '<div class="pdp-test__secours-bas">' + (min !== null ? '<span>dès ' + prix(min) + '</span>' : '<span></span>') + '<a class="pdp-test__secours-lien" href="' + echap(p.produit.u) + '">Voir</a></div></div></div></li>';
  }
  function blocReco(t, k, carteHtml) {
    var p = t.parfum, rem = etat.remplaces[t.i];
    if (carteHtml === undefined && etat.cartesPretes[p.produit.h] !== undefined) carteHtml = etat.cartesPretes[p.produit.h];
    return '<li class="pdp-test__reco' + ((etat.frais || []).indexOf(t.i) >= 0 ? ' nouveau' : '') + '" data-pos="' + k + '" data-i="' + t.i + '">' +
      '<div class="pdp-test__match">' + anneau(t.pct) + '<div class="pdp-test__pourquoi">' +
        (rem ? '<span class="remplace">' + (rem.suite ? 'Entre après votre avis sur ' + echap(rem.nom) : 'Remplace ' + echap(rem.nom) + (rem.raison === 'deja' ? ', que vous avez déjà' : ', qui ne vous plaît pas')) + '</span>' : '') +
        '<span class="pq">' + echap(t.pourquoi) + '</span></div></div>' +
      '<ul class="pdp-test__une" role="list">' + (carteHtml === undefined ? '<li class="pdp-test__attente" aria-hidden="true"></li>' : (carteHtml || secours(p))) + '</ul>' +
      htmlFlacon(p) +
      '<div class="reco-actions"><button type="button" data-raison="deja">Je l\'ai déjà</button><button type="button" data-raison="naime">Je n\'aime pas</button></div>' +
    '</li>';
  }
  // ─── Le grand format ─────────────────────────────────────────────────
  function prix(c) {
    var dev = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: dev }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function htmlFlacon(p) {
    var f = p.flacon;
    // Un décant sans grand format chez nous : on le dit. (Un parfum proposé
    // directement en flacon n'a pas besoin de cette ligne.)
    if (!f || !f.var.length) return p.decant
      ? '<div class="flacon flacon--non"><span class="flacon-titre">' + ICO.svg('flacon', 16) + 'Pas disponible en grand format</span></div>'
      : '<div class="flacon flacon--vide" aria-hidden="true"></div>';
    return '<div class="flacon"><span class="flacon-titre">' + ICO.svg('flacon', 16) + 'Aussi en grand format</span><div class="flacon-choix">' +
      f.var.map(function (v) {
        var ti = /default|title|défaut/i.test(v.ti) ? 'Flacon' : v.ti;
        return '<button type="button" class="flacon-btn" data-flacon="' + v.id + '" aria-label="Ajouter le grand format ' + echap(ti) + ' de ' + echap(p.nom) + ' au panier"><span>' + echap(ti) + '</span><b>' + prix(v.p) + '</b></button>';
      }).join('') +
      '<a class="flacon-lien" href="' + echap(f.u) + '">Voir la fiche</a></div></div>';
  }
  // Le panneau « ajouté au panier » du site (posé par l'aperçu).
  function ouvrirPanneau(items) {
    if (!items || !items.length) return;
    try { if (window.pdpPanneauAjout) window.pdpPanneauAjout.afficher(items, racine); } catch (e) {}
  }
  function notifierPanier() {
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pdp-test-olfactif' }); } catch (e) {}
    }
  }
  function ajouterFlacon(b) {
    if (b.classList.contains('ok') || b.disabled) return;
    var avant = b.innerHTML;
    b.disabled = true;
    envoyer([{ id: +b.getAttribute('data-flacon'), quantity: 1 }]).then(function (r) {
      b.disabled = false;
      if (!r.ok) { toast('Ce grand format n\'est plus disponible.'); return; }
      majPastille(r.corps.sections && r.corps.sections['cart-icon-bubble']);
      notifierPanier();
      ouvrirPanneau(r.corps.items);
      b.classList.add('ok'); b.innerHTML = '<span>✓ Ajouté</span>';
      setTimeout(function () { b.classList.remove('ok'); b.innerHTML = avant; }, 2400);
    }).catch(function () { b.disabled = false; toast('Connexion interrompue : réessayez.'); });
  }
  function brancherFlacons(zone) {
    zone.querySelectorAll('[data-flacon]').forEach(function (b) { b.onclick = function () { ajouterFlacon(b); }; });
  }

  function remplirCartes() {
    etat.affiches.forEach(function (t, k) {
      carteDe(t.parfum).then(function (html) {
        if (html) etat.cartesPretes[t.parfum.produit.h] = html;
        var bloc = app.querySelector('.pdp-test__reco[data-i="' + t.i + '"] .pdp-test__une');
        if (bloc && bloc.querySelector('.pdp-test__attente')) bloc.innerHTML = html || secours(t.parfum);
      });
    });
  }

  // ─── Les coffrets : les 5 en 2, 5 ou 10 ml ───────────────────────────
  var BOXES = [
    { ml: 2, titre: 'Découverte', texte: 'Sentir les 5 sur la peau, tranquillement, avant de choisir.' },
    { ml: 5, titre: 'Découverte & quotidien', texte: 'Les découvrir et les porter quelques jours. Idéal en voyage ou dans un sac.' },
    { ml: 10, titre: 'Adoption', texte: 'Les vivre au quotidien pendant plusieurs semaines avant d\'adopter un flacon.' }
  ];
  function variantesBox(ml) {
    var motif = new RegExp('^\\s*' + ml + '\\s*ml\\s*$', 'i');
    return etat.affiches.map(function (t) {
      var f = t.parfum.decantFiche;
      if (!f) return null;
      var v = (f.var || []).filter(function (x) { return x.ok && motif.test(x.ti); })[0];
      return v ? { id: v.id, nom: t.parfum.nom } : null;
    }).filter(Boolean);
  }
  function majPastille(html) {
    var cible = document.getElementById('cart-icon-bubble');
    if (!cible || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var src = tmp.querySelector('.shopify-section') || tmp;
    cible.innerHTML = src.innerHTML;
    cible.classList.remove('pdp-panier-anime'); void cible.offsetWidth; cible.classList.add('pdp-panier-anime');
  }
  function envoyer(items) {
    return fetch(RACINE_URL + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (c) { return { ok: r.ok, corps: c }; }); });
  }
  function ajouterBox(ml, bouton, zone) {
    var vs = variantesBox(ml);
    if (!vs.length) return;
    bouton.disabled = true; bouton.textContent = '…';
    var ajoutes = [];
    function fin(n, total) {
      bouton.disabled = false; bouton.textContent = 'Ajouter au panier';
      var url = (window.routes && window.routes.cart_url) || RACINE_URL + 'cart';
      zone.innerHTML = n
        ? '<span>' + n + ' décant' + (n > 1 ? 's' : '') + ' de ' + ml + ' ml ajouté' + (n > 1 ? 's' : '') + (n < total ? ' (les autres ne sont plus disponibles dans ce format)' : '') + '. </span><a href="' + url + '">Voir le panier</a>'
        : '<span>Ce coffret n\'a pas pu être ajouté : ces formats ne sont plus disponibles.</span>';
      if (n) {
        notifierPanier();
        var duree = celebrer(bouton.closest('.box'), n, ml);
        // Le panneau s'ouvre quand les décants ont rejoint le panier.
        setTimeout(function () { ouvrirPanneau(ajoutes); }, duree);
      }
    }
    envoyer(vs.map(function (v) { return { id: v.id, quantity: 1 }; }))
      .then(function (rep) {
        if (rep.ok) { ajoutes = rep.corps.items || []; majPastille(rep.corps.sections && rep.corps.sections['cart-icon-bubble']); return fin(vs.length, vs.length); }
        // Un format a manqué : on les envoie un par un, pour garder les autres.
        var n = 0, i = 0;
        function suivant() {
          if (i >= vs.length) return fin(n, vs.length);
          var v = vs[i++];
          return envoyer([{ id: v.id, quantity: 1 }]).then(function (r) {
            if (r.ok) { n++; ajoutes = ajoutes.concat(r.corps.items || []); majPastille(r.corps.sections && r.corps.sections['cart-icon-bubble']); }
          }).catch(function () {}).then(suivant);
        }
        return suivant();
      })
      .catch(function () { bouton.disabled = false; bouton.textContent = 'Ajouter au panier'; zone.textContent = 'Connexion interrompue : réessayez.'; });
  }

  // Le coffret ajouté : les décants apparaissent un à un, une coche se trace,
  // puis ils s'envolent vers le panier.
  function celebrer(box, n, ml) {
    if (!box) return 0;
    var ancien = box.querySelector('.box-fete'); if (ancien) ancien.remove();
    var reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var f = document.createElement('div');
    f.className = 'box-fete'; f.setAttribute('aria-hidden', 'true');
    var fioles = '';
    for (var i = 0; i < n; i++) fioles += '<span class="fiole" style="--i:' + i + '">' + ICO.svg('flacon', 26) + '</span>';
    f.innerHTML = '<div class="fioles">' + fioles + '</div>' +
      '<svg class="coche" viewBox="0 0 52 52"><circle cx="26" cy="26" r="24"></circle><path d="M15 27l7 7 15-16"></path></svg>' +
      '<b>' + (n === 5 ? 'Vos 5 décants' : n + ' décant' + (n > 1 ? 's' : '')) + ' sont dans le panier</b><span>' + n + ' × ' + ml + ' ml</span>';
    box.appendChild(f);
    var bulle = document.getElementById('cart-icon-bubble');
    setTimeout(function () {
      if (reduit || !bulle || !f.isConnected) return;
      var cible = bulle.getBoundingClientRect();
      if (!cible.width || cible.bottom < 0 || cible.top > innerHeight) return;
      f.querySelectorAll('.fiole').forEach(function (el, k) {
        var r = el.getBoundingClientRect(), c = el.cloneNode(true);
        c.className = 'pdp-test-vol';
        c.style.cssText = 'position:fixed;left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;z-index:1000;pointer-events:none;color:#B07D3C';
        document.body.appendChild(c);
        var dx = cible.left + cible.width / 2 - (r.left + r.width / 2), dy = cible.top + cible.height / 2 - (r.top + r.height / 2);
        var a = c.animate([
          { transform: 'translate(0,0) scale(1)', opacity: 1 },
          { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 60) + 'px) scale(.8)', opacity: 1, offset: .55 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.3)', opacity: .2 }
        ], { duration: 750, delay: k * 80, easing: 'cubic-bezier(.5,0,.3,1)', fill: 'forwards' });
        a.onfinish = function () {
          c.remove();
          if (k === n - 1) { bulle.classList.remove('pdp-panier-anime'); void bulle.offsetWidth; bulle.classList.add('pdp-panier-anime'); }
        };
        el.style.visibility = 'hidden';
      });
    }, 1300);
    setTimeout(function () { f.classList.add('sortie'); }, reduit ? 2600 : 2500);
    setTimeout(function () { f.remove(); }, reduit ? 2900 : 2900);
    // Quand ouvrir le panneau : après l'envol des décants vers le panier.
    var vol = bulle && !reduit;
    return vol ? 1300 + 750 + (n - 1) * 80 + 50 : 600;
  }

  // Les parfums déjà testés en décant : le pas suivant, c'est le flacon.
  function htmlTestes() {
    var l = etat.testes.map(function (i) { return CAT.parfums[i]; }).filter(function (p) { return p && p.actif; }).slice(0, 6);
    if (!l.length) return '';
    return '<div class="pdp-test__testes"><p class="surtitre">Vous les avez testés</p><h2>Adoptez-les en grand format</h2>' +
      '<p class="intro-texte">Vous avez déjà commandé ces parfums en décant. S\'ils vous ont plu, passez au grand format.</p><ul role="list">' +
      l.map(function (p) {
        return '<li><div class="testes-nom"><span class="pdp-coll__marque">' + echap(p.maison) + '</span><a href="' + echap((p.flacon || p.produit).u) + '">' + echap(p.nom) + '</a></div>' +
          (p.flacon ? htmlFlacon(p) : '<p class="testes-sans">Pas encore en grand format chez nous. <a href="' + echap(p.produit.u) + '">Le reprendre en décant</a></p>') + '</li>';
      }).join('') + '</ul></div>';
  }
  function htmlPaliers() {
    return (etat.paliers || []).map(function (pa) {
      return '<div class="palier"><span class="niv">Palier ' + pa.palier + ' · ' + echap(pa.titre) + '</span><h3><a href="' + echap(pa.parfum.produit.u) + '">' + echap(pa.parfum.nom) + '</a> <small style="font-family:var(--f-texte);font-size:1.28rem;color:var(--encre-douce)">' + echap(pa.parfum.maison) + '</small></h3><p>' + echap(pa.texte) + '</p></div>';
    }).join('');
  }

  function vueResultat() {
    var m = etat.moteur, pr = etat.profil, top = etat.affiches;
    racine.classList.add('pdp-test--resultat');
    var puces = '<span class="puce puce--or">' + echap(pr.intensite) + '</span><span class="puce">' + echap(pr.moment) + '</span><span class="puce">' + echap(pr.saison) + '</span>' +
      pr.aimes.map(function (a) { return '<span class="puce">' + icoGroupe(a.k) + echap(a.lib) + '</span>'; }).join('') +
      pr.evites.map(function (a) { return '<span class="puce puce--non">' + ICO.svg(a.ico || ICO_GROUPE[a.groupe] || 'evites', 16) + echap(a.lib) + '</span>'; }).join('');
    // Les 3 familles = les 3 branches les plus fortes du graphique : mêmes scores.
    var familles = pr.univers.slice(0, 3).map(function (u, k) {
      return '<div class="famille">' + ICO.univers(u.k, 20) + '<span class="rang">' + (k + 1) + '. ' + echap(COURT[u.k]) +
        (GROUPE_AXE[u.k] ? '<small>' + echap(GROUPE_AXE[u.k]) + '</small>' : '') + '</span><span class="barre"><span style="width:' + u.pct + '%"></span></span><b>' + u.pct + '</b></div>';
    }).join('');
    var express = etat.mode === 'express' || etat.mode === 'express-plus';
    var source = express ? 'version express' + (m.reponses.length ? ' + ' + m.reponses.length + ' questions' : '') : m.reponses.length + ' réponses';
    var ref = express ? etat.express.ref : (etat.journal[0] && etat.journal[0].p);
    app.innerHTML =
      '<section class="ecran anim-entree">' +
        '<div class="pdp-test__profil-ligne">' +
          '<div style="display:grid;gap:14px;align-content:start">' +
            '<p class="surtitre">Votre profil olfactif</p>' +
            '<h1>' + echap(pr.maison.lib) + '</h1>' +
            (familles ? '<div class="familles"><span class="familles-titre">Vos 3 familles olfactives</span>' + familles + '</div>' : '') +
            '<div class="puces">' + puces + '</div>' +
          '</div>' +
          '<div class="profil"><div class="radar-bloc">' + radar(pr.univers, top[0] && top[0].parfum) +
            '<div class="legende"><span><i></i>Votre profil</span>' + (top[0] ? '<span><i class="pointille"></i>' + echap(top[0].parfum.nom) + ', votre n° 1</span>' : '') + '</div>' +
            '<div class="radar-groupes"><p>Chaque branche note votre attirance de 0 à 100 (100 = votre famille la plus forte). Certaines regroupent plusieurs familles :</p><ul>' +
            T.CERCLE.filter(function (k) { return GROUPE_AXE[k]; }).map(function (k) { return '<li><b>' + COURT[k] + '</b> : ' + GROUPE_AXE[k].toLowerCase() + '</li>'; }).join('') + '</ul></div>' +
          '</div></div>' +
        '</div>' +
        '<div class="actions actions--avant"><p>Ce profil ne vous ressemble pas tout à fait ?</p><button class="btn" type="button" id="b-plus">Affiner : 3 questions de plus</button><button class="btn btn--clair" type="button" id="b-refaire">Refaire le test</button></div>' +
        '<p class="etiquette">Votre sélection · ' + source + (ref ? ' · inspirée de ' + echap(ref.nom) : '') + '</p>' +
        '<p class="intro-texte">Vous avez déjà un de ces parfums, ou il ne vous dit rien ? Dites-le : nous le remplaçons, et la sélection s\'ajuste.</p>' +
        '<div class="pdp-test__compte" data-pdp-compte role="status" hidden></div>' +
        '<p class="pdp-test__maj" role="status" aria-live="polite"></p>' +
        '<ul class="pdp-test__grille" role="list" id="pdp-test-selection">' + top.map(function (t, k) { return blocReco(t, k); }).join('') + '</ul>' +
        '<div class="pdp-test__ecartes" data-ecartes>' + htmlEcartes() + '</div>' +
        htmlTestes() +
        '<p class="surtitre" style="margin-top:14px">Découvrir ma sélection</p>' +
        '<h2>Vos 5 parfums, en un coffret</h2>' +
        '<p class="intro-texte">Les décants de votre sélection, dans le format de votre choix. La remise de −20 % s\'applique d\'office dès 2 décants.</p>' +
        '<div class="boxes">' + BOXES.map(function (b, k) {
          var n = variantesBox(b.ml).length;
          var conseil = racine.getAttribute('data-coffret-conseil') || '5', mise = conseil === String(b.ml);
          var etiquette = racine.getAttribute('data-coffret-conseil-texte') || '';
          var visuel = racine.getAttribute('data-coffret-image-' + b.ml);
          return '<div class="box' + (mise ? ' box--mise' + (etiquette ? ' box--conseil' : '') : '') + (visuel ? ' box--visuel' : '') + '">' +
            (visuel ? '<div class="box__visuel" aria-hidden="true"><img src="' + echap(visuel) + '" alt="" loading="lazy"></div>' : '') +
            (mise && etiquette ? '<span class="box__conseil">' + echap(etiquette) + '</span>' : '') +
            '<span class="format">' + n + ' × ' + b.ml + ' ml</span><h3>' + b.titre + '</h3><p>' + b.texte + '</p>' +
            (n ? '<button class="btn" type="button" data-box="' + b.ml + '">Ajouter au panier</button>' : '<p><i>Pas disponible dans ce format pour votre sélection.</i></p>') +
            '<p class="pdp-test__box-msg" data-box-msg="' + b.ml + '" role="status"></p></div>';
        }).join('') + '</div>' +
        '<p class="surtitre" style="margin-top:14px">Sortir de votre zone de confort</p>' +
        '<h2>Trois pas, à votre rythme</h2>' +
        '<p class="intro-texte">Chaque palier vous éloigne un peu plus de vos habitudes, sans jamais revenir vers ce que vous avez écarté.</p>' +
        '<div class="paliers">' + htmlPaliers() + '</div>' +
      '</section>';
    remplirCartes();
    carrousel(app.querySelector('#pdp-test-selection'));
    brancherSelection();
    brancherEcartes();
    brancherFlacons(app);
    sauver();
    majStatut();
    app.querySelectorAll('[data-box]').forEach(function (b) {
      b.onclick = function () { var ml = +b.getAttribute('data-box'); ajouterBox(ml, b, app.querySelector('[data-box-msg="' + ml + '"]')); };
    });
    document.getElementById('b-plus').onclick = function () {
      racine.classList.remove('pdp-test--resultat');
      var n = m.reponses.length;
      m.MAX = n + 3; m.MIN = n + 3; m.SEUIL = 2; etat.jaugeMax = 0; etat.jaugeN = undefined;
      etat.reglages = { MAX: m.MAX, MIN: m.MIN, SEUIL: m.SEUIL };
      if (etat.mode === 'express') etat.mode = 'express-plus';
      suivante();
    };
    document.getElementById('b-refaire').onclick = function () { oublier(); racine.classList.remove('pdp-test--resultat'); vueIntro(); };
  }
  /* Une recommandation écartée. Le moteur en tient compte (« je n'aime pas » :
     ses voisins descendent ; « je l'ai déjà » : ses voisins montent un peu),
     puis la sélection est recalculée en entier et RE-CLASSÉE : le n° 1 est
     toujours le parfum qui colle le mieux au profil, jamais un remplaçant
     posé à la place d'un autre. Un voisin du parfum écarté peut donc sortir
     lui aussi. L'échelle des % reste celle du résultat de départ. */
  function selection() {
    var m = etat.moteur, P = m.parfums;
    return m.classement().filter(function (i) { return !m.exclus[i] && dispo(P[i]); }).slice(0, 5)
      .map(function (i) { return { i: i, parfum: P[i], pct: m.pct(i), pourquoi: m.pourquoi(P[i]) }; });
  }
  function ecarter(i, raison) {
    var m = etat.moteur, parti = m.parfums[i];
    var avant = etat.affiches.map(function (t) { return t.i; });
    m.rejeter(i, raison);
    var neuf = selection();
    if (!neuf.length) return null;
    var apres = neuf.map(function (t) { return t.i; });
    var entres = apres.filter(function (x) { return avant.indexOf(x) < 0; });
    var sortis = avant.filter(function (x) { return x !== i && apres.indexOf(x) < 0; });
    delete etat.remplaces[i];
    // Le mieux placé des nouveaux remplace le parfum écarté ; les autres entrent par ricochet.
    entres.forEach(function (x, n) { etat.remplaces[x] = { nom: parti.nom, raison: raison, suite: n > 0 }; });
    // Un parfum sorti n'a plus de mention s'il revient plus tard.
    sortis.forEach(function (x) { delete etat.remplaces[x]; });
    etat.affiches = neuf;
    etat.frais = entres;
    etat.rejets.push({ h: cleP(parti), raison: raison });
    etat.paliers = m.paliers(etat.profil, apres, etat.profil.evites, dispo);
    return { parti: parti, sortis: sortis.map(function (x) { return m.parfums[x]; }), entres: entres, avant: avant };
  }
  function phraseMaj(r) {
    var t = (r.parti.nom) + ' est retiré de votre sélection';
    if (r.sortis.length) t += ', ainsi que ' + r.sortis.map(function (p) { return p.nom; }).join(' et ') + ', trop proche' + (r.sortis.length > 1 ? 's' : '');
    var neuf = etat.affiches.map(function (x) { return x.i; });
    var bouge = neuf.some(function (x, k) { return r.avant.indexOf(x) >= 0 && r.avant.indexOf(x) !== k; });
    return t + '. ' + (bouge || r.entres.some(function (x) { return neuf.indexOf(x) < neuf.length - r.entres.length; }) ? 'Le classement est mis à jour.' : 'La sélection est complétée.');
  }
  // Sur mobile, la sélection défile en carrousel : des points suivent la carte vue.
  function carrousel(ul) {
    if (!ul || ul.__car) return; ul.__car = true;
    var nav = document.createElement('div'); nav.className = 'carrousel-points'; nav.setAttribute('aria-hidden', 'true');
    ul.parentNode.insertBefore(nav, ul.nextSibling);
    function actif() {
      var it = ul.children; if (!it.length) return 0;
      if (ul.scrollLeft >= ul.scrollWidth - ul.clientWidth - 2) return it.length - 1;
      var o = it[0].offsetLeft, best = 0, d = Infinity;
      for (var i = 0; i < it.length; i++) { var dd = Math.abs(it[i].offsetLeft - o - ul.scrollLeft); if (dd < d) { d = dd; best = i; } }
      return best;
    }
    function maj() {
      var n = ul.children.length;
      if (nav.children.length !== n) nav.innerHTML = new Array(n + 1).join('<i></i>');
      var a = actif();
      Array.prototype.forEach.call(nav.children, function (b, i) { b.className = i === a ? 'on' : ''; });
    }
    var rq = 0;
    ul.addEventListener('scroll', function () { cancelAnimationFrame(rq); rq = requestAnimationFrame(maj); }, { passive: true });
    if (window.MutationObserver) new MutationObserver(maj).observe(ul, { childList: true });
    maj();
  }
  // Re-dessine la grille ; les cartes restées glissent à leur nouvelle place.
  function majGrille(r) {
    var grille = app.querySelector('#pdp-test-selection');
    if (!grille) return;
    var pos = {};
    grille.querySelectorAll('.pdp-test__reco').forEach(function (li) { pos[li.getAttribute('data-i')] = li.getBoundingClientRect(); });
    grille.innerHTML = etat.affiches.map(function (t, k) { return blocReco(t, k); }).join('');
    var reduit = matchMedia('(prefers-reduced-motion: reduce)').matches;
    grille.querySelectorAll('.pdp-test__reco').forEach(function (li) {
      var avant = pos[li.getAttribute('data-i')];
      if (!avant || reduit || !li.animate) return;
      var ici = li.getBoundingClientRect(), dx = avant.left - ici.left, dy = avant.top - ici.top;
      if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
      li.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 450, easing: 'cubic-bezier(.2,.7,.3,1)' });
    });
    remplirCartes();
    brancherFlacons(grille);
    brancherSelection();
    var maj = app.querySelector('.pdp-test__maj');
    if (maj && r) {
      maj.textContent = r.texte || phraseMaj(r);
      // Une erreur de clic ? « Annuler » remet le parfum à sa place.
      if (!r.texte) {
        var an = document.createElement('button');
        an.type = 'button'; an.className = 'pdp-test__annuler'; an.textContent = 'Annuler';
        an.onclick = function () { retablir(cleP(r.parti)); };
        maj.appendChild(document.createTextNode(' ')); maj.appendChild(an);
      }
    }
    var ec = app.querySelector('[data-ecartes]');
    if (ec) { ec.innerHTML = htmlEcartes(); brancherEcartes(); }
    var pal = app.querySelector('.paliers'); if (pal) pal.innerHTML = htmlPaliers();
    // Le pointillé de la toile suit le nouveau n° 1.
    var top1 = etat.affiches[0] && etat.affiches[0].parfum, toile = app.querySelector('svg.radar'), leg = app.querySelector('.radar-bloc .legende');
    if (toile) toile.outerHTML = radar(etat.profil.univers, top1);
    if (leg) leg.innerHTML = '<span><i></i>Votre profil</span>' + (top1 ? '<span><i class="pointille"></i>' + echap(top1.nom) + ', votre n° 1</span>' : '');
    // Le nombre de décants par coffret peut changer.
    BOXES.forEach(function (bx) { var f = app.querySelector('[data-box="' + bx.ml + '"]'); if (f) f.closest('.box').querySelector('.format').textContent = variantesBox(bx.ml).length + ' × ' + bx.ml + ' ml'; });
  }
  // Les parfums écartés, chacun rétablissable.
  function htmlEcartes() {
    if (!etat.rejets.length) return '';
    return '<span>Écartés de votre sélection :</span>' + etat.rejets.map(function (r) {
      var p = parCle(r.h);
      if (!p) return '';
      return '<button type="button" data-retablir="' + echap(r.h) + '" aria-label="Remettre ' + echap(p.nom) + ' dans ma sélection">' +
        echap(p.nom) + '<small>' + (r.raison === 'deja' ? 'déjà' : 'pas aimé') + '</small><b aria-hidden="true">×</b></button>';
    }).join('');
  }
  function brancherEcartes() {
    app.querySelectorAll('[data-retablir]').forEach(function (b) { b.onclick = function () { retablir(b.getAttribute('data-retablir')); }; });
  }
  /* Rétablir un parfum écarté : on rejoue le test SANS cet avis. Le classement
     redevient exactement celui qu'il aurait été sans lui ; le parfum revient à
     sa place (et ses voisins aussi, s'ils étaient sortis à cause de lui). */
  function retablir(h) {
    var S = trace();
    S.rejets = (S.rejets || []).filter(function (r) { return r.h !== h; });
    var avant = etat.affiches.map(function (t) { return t.i; });
    if (!appliquer(S, true)) return;
    var p = parCle(h), i = p ? CAT.parfums.indexOf(p) : -1;
    etat.frais = etat.affiches.map(function (t) { return t.i; }).filter(function (x) { return avant.indexOf(x) < 0; });
    sauver();
    majGrille({ texte: (p ? p.nom : 'Ce parfum') + (etat.affiches.some(function (t) { return t.i === i; }) ? ' est de retour dans votre sélection.' : ' n\'est plus écarté.') });
  }
  // « Je l'ai déjà » / « Je n'aime pas ».
  function brancherSelection() {
    app.querySelectorAll('#pdp-test-selection > .pdp-test__reco').forEach(function (li) {
      li.querySelectorAll('[data-raison]').forEach(function (b) {
        b.onclick = function () {
          var i = +li.getAttribute('data-i'), raison = b.getAttribute('data-raison');
          var r = ecarter(i, raison);
          if (!r) { toast('Plus d\'autre parfum à vous proposer ici.'); return; }
          sauver();
          majGrille(r);
        };
      });
    });
  }

  if (!restaurer()) vueIntro();
  // La page du test relit toujours le compte : un avis retiré depuis
  // « Mon espace parfum » doit être repris tout de suite.
  if (COMPTE) COMPTE.etat(true).then(compteArrive);
  }

  // ─── Chargement : les fiches écrites par la section, page par page ────
  /* Shopify n'écrit que 250 produits par page. Les suivantes sont demandées
     à la même section (« ?section_id=…&page=N ») et ajoutées. */
  function lireDonnees(racine) {
    function lire(el) { try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; } }
    var el = racine.querySelector('[data-pdp-test-donnees]');
    var produits = lire(el);
    var pages = parseInt(el && el.getAttribute('data-pages'), 10) || 1;
    var id = racine.getAttribute('data-section');
    var suites = [];
    for (var n = 2; n <= pages; n++) {
      suites.push(fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id) + '&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return lire(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdp-test-donnees]')); })
        .catch(function () { return []; }));
    }
    return Promise.all(suites).then(function (l) { l.forEach(function (x) { produits = produits.concat(x); }); return produits; });
  }
  function init() {
    document.querySelectorAll('[data-pdp-test]').forEach(function (racine) {
      if (racine.hasAttribute('data-pdp-test-pret')) return;
      racine.setAttribute('data-pdp-test-pret', '');
      lireDonnees(racine).then(function (produits) {
        var cat = window.PdpTestCatalogue.construire(produits);
        if (!cat.parfums.some(function (p) { return p.dispo; })) {
          racine.querySelector('[data-pdp-test-app]').innerHTML = '<p class="intro-texte">Le test est momentanément indisponible.</p>';
          return;
        }
        lancer(racine, cat);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();